import React, { useContext, useEffect, useState, useMemo, useRef, useCallback } from "react";
import { useHistory } from 'react-router-dom';
import * as locales from '@mui/material/locale';
import { useTheme, ThemeProvider, createTheme, styled } from "@mui/material/styles";
import { MyContext } from '../../context/MyContext';
import { ReactToPrint, useReactToPrint } from 'react-to-print';
// import { Grid, Card } from '@mui/material';
import { DataGrid, gridClasses, GridToolbarContainer, GridToolbarExport, GridLinkOperator, getGridDateOperators, filterModel } from '@mui/x-data-grid';
import { useDemoData } from '@mui/x-data-grid-generator';
import { GridCellParams } from '@mui/x-data-grid';
// import { aceitaApenasNumerosAndTraco, convertDateTimeFinalDia, formatarTelefone, formatarDataHora, numberWithCommas, aceitaApenasNumeros, identificacaoUsuarioLogado, identificacaoRazaoSocialUsuarioLogado, tipoDeNotaFaturada, aceitaApenasDatas, identificacaoNomeUsuarioLogado } from '../../utils';
import { validaCpfCnpj, aceitaApenasNumeros, formatarDataHora, convertDateTimeFinalDia, tipoDeNotaFaturada, CartaoCreditoTipo, identificacaoUsuarioLogado, identificacaoRazaoSocialUsuarioLogado, identificacaoNomeUsuarioLogado, identificaoEnderecoEntrega, numberWithCommas, identificaTipoOperacaoContasFaturadas } from '../../utils';
// import Box from '@mui/material/Box';
import { isBefore } from 'date-fns';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Checkbox from '@mui/material/Checkbox';
import InputLabel from '@mui/material/InputLabel';
import api from '../../services/api';
import { ToastContainer, toast } from 'react-toastify';
import { makeStyles } from "@mui/styles";
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import SetaDireita from '../../../src/assets/img/seta_direita.svg';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import ArchiveIcon from '@mui/icons-material/Archive';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Switch from '@mui/material/Switch';
import IconButton from '@mui/material/IconButton';
import ReceiptIcon from '@mui/icons-material/Receipt';
import OutlinedInput from '@mui/material/OutlinedInput';
import Avatar from '@mui/material/Avatar';
import PagamentoIcon from '../../assets/img/pagamento.svg';
import Divider from '@mui/material/Divider';
import LogoNameOneLine from '../../assets/img/NAFIL_logo_one_line.svg';
import LogoRedeItau from '../../assets/img/rede_itau.svg';
import Dialogo from '../Dialogo/Dialogo';
import cartoes_selecaoIcon from '../../assets/img/cartoes_selecao.svg';
import cartoes_selecaoIconDisabled from '../../assets/img/cartoes_selecao_disabled.svg';
import boletoIcon from '../../assets/img/boleto.svg';
import boletoIconDisabled from '../../assets/img/boleto_disabled.svg';
import pixIcon from '../../assets/img/pix.svg';
import pixIconDisabled from '../../assets/img/pix_disabled.svg';
import cartoes_AMEX from '../../assets/img/cartoes_amex.svg';
import cartoes_ELO from '../../assets/img/cartoes_elo.svg';
import cartoes_DINERS from '../../assets/img/cartoes_diners.svg';
import cartoes_VISA from '../../assets/img/cartoes_visa.svg';
import cartoes_MASTERCARD from '../../assets/img/cartoes_mastercard.svg';
import cartoes_HIPERCARD from '../../assets/img/cartoes_hipercard.svg';
import cartoes_HIPER from '../../assets/img/cartoes_hiper.svg';
import cartoes_CABAL from '../../assets/img/cartoes_cabal.svg';
import cartoes_CVV from '../../assets/img/cartoes_cvv.svg';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import moment from "moment";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import 'dayjs/locale/pt-br';
import {
    TextField,
    Grid,
    Typography,
    Container,
    Box,
    Paper,
    Card,
    CardContent,
    CardActions,
    Button,
    Stack
} from "@mui/material";
import MeusCheques from "../MeusCheques/MeusCheques";
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import DetalhesMeusCheques from '../../components/MeusCheques/MeusCheques';
import Backdrop from '@mui/material/Backdrop';
import { MultilineChart } from "@mui/icons-material";
import { BrowserView, MobileView } from 'react-device-detect';
// import { useHistory } from 'react-router-dom';

const useStyles = makeStyles({
    bege: {
        backgroundColor: "#FFFFF0"
    },
    branco: {
        backgroundColor: "#FFFFFF"
    },
});

function Compras_Faturadas(props) {
    const gridRef = useRef(null);
    let navigate = useHistory();
    const _marcados = [];
    const { destinoPagina, setDestinoPagina } = useContext(MyContext);
    const { usuarioComprasFaturadas, setUsuarioComprasFaturadas } = useContext(MyContext);
    const [saton, setSaton] = useState([]);
    const [satonOriginal, setSatonOriginal] = useState([]);
    const [satonImpressaoItens, setSatonImpressaoItens] = useState([]);
    const [satonImpressaoEspecie, setSatonImpressaoEspecie] = useState([]);
    const [satonImpressaoFator, setSatonImpressaoFator] = useState(null);
    const [iniciarImpressao, setIniciarImpressao] = useState("");
    const [satonImpressaoProcessoId, setSatonImpressaoProcessoId] = useState(0);
    const [satonImpressaoProcessoIdLoja, setSatonImpressaoProcessoIdLoja] = useState(0);
    const [conteudoParaImpressao, setConteudoParaImpressao] = useState("");
    const [locale, setLocale] = useState('ptBR');
    const theme = useTheme();
    const themeWithLocale = useMemo(() => createTheme(theme, locales[locale]), [locale, theme]);
    const [usuarioLogado, setUsuarioLogado] = useState("");
    const [nomeUsuarioLogado, setNomeUsuarioLogado] = useState("");
    const [nomeFullRazaoSocialLogado, setNomeFullRazaoSocialLogado] = useState("");    
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    const [selectionModelMarcados, setSelectionModelMarcados] = React.useState([]);
    const [selectionModelDevolucoes, setSelectionModelDevolucoes] = React.useState([]);
    const [selectionModelNotaInteira, setSelectionModelNotaInteira] = useState([]);
    const [selectionModelLinhaAtual, setSelectionModelLinhaAtual] = useState({});
    const [selectionModelUltimaNota, setSelectionModelUltimaNota] = useState("");
    const [quantidadeTotalVendas, setQuantidadeTotalVendas] = useState(0);
    const [valorTotalVendas, setValorTotalVendas] = useState(0.00);
    const [quantidadeTotalCreditos, setQuantidadeTotalCreditos] = useState(0);
    const [valorTotalCreditos, setValorTotalCreditos] = useState(0.00);
    const [quantidadeTotalDevolucoes, setQuantidadeTotalDevolucoes] = useState(0);
    const [valorTotalDevolucoes, setValorTotalDevolucoes] = useState(0.00);
    const [quantidadeTotalDuplicatas, setQuantidadeTotalDuplicatas] = useState(0);
    const [valorTotalDuplicatas, setValorTotalDuplicatas] = useState(0.00);
    const [quantidadeTotalChequesDevolvidos, setQuantidadeTotalChequesDevolvidos] = useState(0);
    const [valorTotalChequesDevolvidos, setValorTotalChequesDevolvidos] = useState(0.00);
    const [totalGeral, setTotalGeral] = useState(0.00);
    const [dataGridPositionY, setDataGridPositionY] = useState(266);
    const [confirmouCancelamento, setConfirmouCancelamento] = useState(false);    // usado para indicar se faltar item poderá ser cancelado
    const [confirmouCancelamentoError, setConfirmouCancelamentoError] = useState("");
    const [quantidadeTotalVendasPagamentos, setQuantidadeTotalVendasPagamentos] = useState(0);
    const [valorTotalVendasPagamentos, setValorTotalVendasPagamentos] = useState(0.00);
    const [quantidadeTotalCreditosPagamentos, setQuantidadeTotalCreditosPagamentos] = useState(0);
    const [valorTotalCreditosPagamentos, setValorTotalCreditosPagamentos] = useState(0.00);
    const [quantidadeTotalDevolucoesPagamentos, setQuantidadeTotalDevolucoesPagamentos] = useState(0);
    const [valorTotalDevolucoesPagamentos, setValorTotalDevolucoesPagamentos] = useState(0.00);

    const [quantidadeTotalDescontosPagamentos, setQuantidadeTotalDescontosPagamentos] = useState(0);
    const [valorTotalDevolucoesPagamentosDescontosPagamentos, setValorTotalDescontosPagamentos] = useState(0.00);

    const [descontoPagamentoAVista, setDescontoPagamentoAVista] = useState({});
    const [quantidadeDescontosPagamentos, setQuantidadeDescontosPagamentos] = useState(0);
    const [valorDescontosPagamentos, setValorDescontosPagamentos] = useState(0.00);
    const [listaItensFaturadosDescontosPagamentos, setListaItensFaturadosDescontosPagamentos] = useState([]);

    const [totalGeralPagamentos, setTotalGeralPagamentos] = useState(0.00);

    const [showModalMeusCheques, setShowModalMeusCheques] = useState(false);
    const [openMeusCheques, setOpenMeusCheques] = useState(false);
    const [retornoApi, setRetornoApi] = useState({});

    const [filtroCodigo, setFiltroCodigo] = useState(null);
    const [filtroDataInicial, setFiltroDataInicial] = useState("");
    const [filtroDataFinal, setFiltroDataFinal] = useState({});
    const [filtroIDVenda_Loja, setFiltroIDVenda_Loja] = useState(null);
    const [filtroAtivo, setFiltroAtivo] = useState(false);

    const [switchAbertas, setSwitchAbertas] = useState(true);
    const label = { inputProps: { 'aria-label': 'Switch demo' } };
    const { meuFormaPagamentoTipo, setMeuFormaPagamentoTipo } = useContext(MyContext); // Tipo de Pagamento 1 - PIX / 2 - BOLETO / 3 - CARTÃO CRÉDITO ou DÉBITO
    const [pagamentoNumeroMaximoParcelas, setPagamentoNumeroMaximoParcelas] = useState({});

    const [cartaoSelecionado, setCartaoSelecionado] = useState("cartoes_CVV");
    const [cartaoTipoCartao, setCartaoTipoCartao] = useState(0);
    const [cartaoSolicitarCPF_CNPJ, setCartaoSolicitarCPF_CNPJ] = useState(true);
    const [cartaoDigitadoNumero, setCartaoDigitadoNumero] = useState("");
    const [cartaoNumeroError, setCartaoNumeroError] = useState("");
    const [cartaoDigitadoNome, setCartaoDigitadoNome] = useState("");
    const [cartaoNomeError, setCartaoNomeError] = useState("");
    const [cartaoDigitadoValidade, setCartaoDigitadoValidade] = useState("");
    const [cartaoDigitadoCVV, setCartaoDigitadoCVV] = useState("");
    const [cartaoDigitadoCPFCNPJ, setCartaoDigitadoCCPFCNPJ] = useState("");
    const [pagamentoNumeroParcelas, setPagamentoNumeroParcelas] = useState(0);
    const [pagamentoOpcaoSelecionada, setPagamentoOpcaoSelecionada] = React.useState("");
    const [pagamentoNumeroParcelasError, setPagamentoNumeroParcelasError] = useState("");
    const [pagamentoValorParcelas, setPagamentoValorParcelas] = useState([]);
    const [cpf_cnpjError, setCpf_cnpjError] = useState("");
    const [vencimentoError, setVencimentoError] = useState("");
    const [filt, setFilt] = useState([]);
    const [dates, setDates] = React.useState({});
    const [pageSizeContaFaturada, setPageSizeContaFaturada] = useState(100);
    const [openDialogoDevolucoes, setOpenDialogoDevolucoes] = useState(false);
    const [dialogoMensagemDevolucoes, SetDialogoMensagemDevolucoes] = useState("");
    const [totalProdutos, setTotalProdutos] = useState(0.00);
    const [totalFrete, setTotalFrete] = useState(0.00);
    const [totalDescontos, setTotalDescontos] = useState(0.00);
    const [totalCreditos, setTotalCreditos] = useState(0.00);
    const [satonModelClass, setSatonModelClass] = useState({});
    const [registrosSaton, setRegistrosSaton] = useState({
        ids_saton: 0,
        ids_saton_loja: 0,
        id_cliente: 0,
        id_cliente_loja: 0
    });

    // const [fator, setFator] = useState({
    //   ids_fator: 0,
    //   ids_loja_fator: 0,
    //   id_cliente: 0,
    //   id_loja_cliente: 0,
    //   data: "1997-01-01T00:00:00",
    //   computador: '',
    //   subtotal: 0,
    //   desconto: 0,
    //   credito: 0,
    //   devolucao: 0,
    //   total: 0,
    //   pago: 0,
    //   user_recebimento: 0,
    //   user_cancelamento: null,
    //   data_cancelamento: null,
    //   pagamento_pendente: 0,
    //   pagamento_pendente_ate: null,
    //   pagamento_pendente_tipo: ''
    // })

    // const [especie, setEspecie] = useState({
    //   especie_id: 0,
    //   especie_loja: 0,
    //   venda_id: 0,
    //   venda_loja: 0,
    //   data: "1997-01-01T00:00:00",
    //   tipo: '',
    //   valor: 0,
    //   vezes: null,
    //   usuario: null,
    //   caixa: null,
    //   retorno: '',
    //   codctf: '',
    //   respdll: '',
    //   operadora_cnpj: '',
    //   cartao: '',
    //   bandeira: '',
    //   codautor: '',
    //   retautor: '',
    //   nsu: '',
    //   nsuautor: '',
    //   aprovacao: '',
    //   van: '',
    //   operadora: '',
    //   autorizadora: '',
    //   transacao: null,
    //   modo: '',
    //   resposta: '',
    //   nband: null,
    //   disk: null,
    //   finalizado: null,
    //   tipo_integracao: 0,
    //   tid: '',
    //   presencial: 0,
    //   pix_txid: '',
    //   pix_validade: null,
    //   pix_recebido: null,
    //   pix_location: '',
    //   ordem: null,
    //   processo_id: 0,
    //   processo_id_loja: 0
    // });

    // const [duplicata, setDuplicata] = useState({
    //   ids_duplicata: 0,
    //   ids_loja_duplicata: 0,
    //   id_cliente: 0,
    //   id_cliente_loja: 0,
    //   emissao: "1997-01-01T00:00:00",
    //   vencimento: "1997-01-01T00:00:00",
    //   nfe_numero: null,
    //   nfe_serie: null,
    //   nfe_filial: null,
    //   user_criado: 0,
    //   user_pagamento: null,
    //   data_pagamento: null,
    //   contador: '',
    //   valor_duplicata: 0,
    //   linha_digitavel: '',
    //   codigo_barras: '',
    //   enviado: 0,
    //   enviado_data: null,
    //   retorno_duplicata: '',
    //   processo: 0,
    //   processo_loja: null,
    //   arquivo: '',
    //   pedido_online_id: 0,
    //   pedido_online_id_loja: 0,
    // });

    const [listaPreDevoucoes, setListaPreDevolucoes] = useState([]);
    const [preDevolucao, setPreDevolucao] = useState({
        "ids_saton": "",
        "ids_saton_loja": "",
        "id_cliente": "",
        "id_cliente_loja": "",
        "quantidade": "",
        "codigo": "",
        "descricao": "",
        "unitario": "",
        "total": "",
        "especie": "",
        "data": "",
        "data_devolucao": "",
        "vencimento": "",
        "id_venda": "",
        "id_venda_loja": "",
        "vendedor": "",
        "placa": "",
        "processo": "",
        "processo_loja": "",
        "observacao": "",
        "nfe_loja": "",
        "nfe_coo": "",
        "nfe_serie": "",
        "nfe_mod": "",
        "user_devolucao": "",
        "processo_devolucao": "",
        "processo_devolucao_loja": ""
    });

    const handlePrint = async () => {
        if (selectionModel == null || selectionModel.length == 0) {
            toastMarcarItensParaImpressao();
        }
        let _itensSelecionados = [];

        selectionModel.forEach((item) => {
            if (item.substring(0, 1) == "-") {
                _itensSelecionados.push(item.substring(1, item.length));
            }
            else {
                _itensSelecionados.push(item);
            }
        });

        _itensSelecionados = satonOriginal.filter((item) => {
            return _itensSelecionados.includes(item.ids_saton.toString() + "-" + item.ids_saton_loja.toString());
        });

        let _processosSelecionados = [];
        _itensSelecionados.forEach((item) => {
            if (item.processo != null) { // } && item.processo > 0) {
                let _registroProcesso = item.processo + "-" + item.processo_loja;
                if (_processosSelecionados.indexOf(_registroProcesso) === -1) {
                    _processosSelecionados.push(_registroProcesso);
                }
            }
        });

        let usuario_logado = identificacaoUsuarioLogado();
        let _userId = usuario_logado.split('_')[0];
        let _userIdloja = usuario_logado.split('_')[1];
        //        let satonImpressaoItens = [];
        //        let satonImpressaoPagamentos = [];
        //        let arrayDeObjetos = [];
        //_processosSelecionados.forEach((itemSelect) => {
        for (const itemSelect of _processosSelecionados) {
            setSatonImpressaoProcessoId(itemSelect.split('-')[0]);
            setSatonImpressaoProcessoIdLoja(itemSelect.split('-')[1]);

            let _htmlPrint = "";
            let _retProntParaImprimir = await createGetExtratos(itemSelect.split('-')[0], itemSelect.split('-')[1]);

            if (_retProntParaImprimir) {
                setSatonImpressaoEspecie(_retProntParaImprimir.especieParcial);
                setSatonImpressaoFator(_retProntParaImprimir.fatorParcial);
                setSatonImpressaoItens(_retProntParaImprimir.satonParcial);

                console.log("CRIS ", _retProntParaImprimir.especieParcial);

                setIniciarImpressao(itemSelect.split('-')[0] + "-" + itemSelect.split('-')[1]);
            }

        };
    };

    const GerarImpressao = async (_satonImpressaoItens, _satonImpressaoEspecie) => {
        let imprimirDoc = null;
        if (_satonImpressaoItens === undefined || _satonImpressaoItens.length == 0) {
            return;
        }
        // MONTAR A IMPRESSÃO INÍCIO

        let _impressaoTop = `<!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width, initial-scale=1">
            <title>Extrato NAFIL Auto Peças - Processo ${_satonImpressaoItens[0].processo + "-" + _satonImpressaoItens[0].processo_loja}</title>
            <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65" crossorigin="anonymous">
          </head>
        <body onload="window.print()" onfocus="window.close()">
         <div id ="impressao">
         <table class="table" style="background-color: #F2F2F2;">
          <tr>
           <th scope="col" style="font-weight: normal; font-size: 10px;"><img src=${LogoNameOneLine}  width="180" height="auto"></img></th>
           <th scope="col" colspan="3" style=" font-size: 10px; line-height: 5px; vertical-align: top; padding-top: 20px;">Processo: #ProcessoID# Efetuado Dia: #ProcessoDia# Contendo: #ProcessoItens#</th>
          </tr>
          <tr>
            <th scope="col" style="font-weight: normal; font-size: 10px; width: 10%; line-height: 5px;">Quant.</th>
            <th scope="col" style="font-weight: normal; font-size: 10px; width: 15%; line-height: 5px;">Código</th>
            <th scope="col" style="font-weight: normal; font-size: 10px; width: 60%; line-height: 5px;">Descrição</th>
            <th scope="col" style="font-weight: normal; font-size: 10px; width: 15%; line-height: 5px;">Total R$</th>
          </tr>
         </table>`;

        let _impressaoRodape = `
        </div>
        </body>
        </html>`;

        let _linhas = "";

        let _cabecalhoNota = `<table class="table" style="margin-top:-16px; background-color: #corAtual#">
        <tr style="width: 100%; line-height: 8px; background-color: #corAtual#">
         <td style="font-weight: bold; line-height: 8px; font-size: 10px; width: 100%; background-color: #corAtual#">Dia&nbsp;&nbsp;#dataNota#&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;#tipoOperacao#&nbsp;&nbsp;#numeroNota#</td>
        </tr>          
        </table>
        <table class="table" style="margin-top:-16px; background-color: #corAtual#">`;

        let _linhaItens = `
          <tr>
            <th scope="col" style="color: #fontColor#; font-weight: normal; font-size: 10px; width: 10%; line-height: 8px;">#quantidade#</th>
            <th scope="col" style="color: #fontColor#; font-weight: normal; font-size: 10px; width: 15%; line-height: 8px;">#codigo#</th>
            <th scope="col" style="color: #fontColor#; font-weight: normal; font-size: 10px; width: 60%; line-height: 8px;">#descricao#</th>
            <th scope="col" style="color: #fontColor#; font-weight: normal; font-size: 10px; width: 15%; text-align: right; padding-right: 20px; line-height: 8px;">#total#</th>
          </tr>`;

        let _linhaItensTotal = `
          </table>
          <table class="table" style="margin-top:-16px; background-color: #corAtual#">
          <tr style="line-height: 8px;">
          <td style="line-height: 8px; background-color: #corAtual#"></td>
          <td style="line-height: 8px; background-color: #corAtual#"></td>
          <td style="text-align: right; line-height: 8px; font-weight: bold; font-size: 11px; background-color: #corAtual#;">Total R$</td>
          <td style="text-align: right; line-height: 8px; font-weight: bold; font-size: 11px; background-color: #corAtual#; padding-right: 20px;">#subtotal#</td>
         </tr>
         </table>`;

        let _linhaTotalPagamentos = `
          <table class="table" style="margin-top:-16px; background-color: #corAtual#">
            <tr style="line-height: 12px;">
            <td colspan="4" style="border: none; line-height: 8px; background-color: #corAtual#"></td>
            </tr>
            <tr style="line-height: 8px;">
            <td style="line-height: 8px; background-color: #corAtual#"></td>
            <td style="line-height: 8px; background-color: #corAtual#"></td>
            <td style="text-align: right; line-height: 8px; font-weight: bold; font-size: 11px; background-color: #corAtual#;">Total em Produtos R$</td>
            <td style="text-align: right; line-height: 8px; font-weight: bold; font-size: 11px; background-color: #corAtual#; padding-right: 20px;">#subtotalprodutos#</td>
            </tr>
            <tr style="line-height: 8px;">
            <td style="line-height: 8px; background-color: #corAtual#"></td>
            <td style="line-height: 8px; background-color: #corAtual#"></td>
            <td style="text-align: right; line-height: 8px; font-weight: bold; font-size: 11px; background-color: #corAtual#;">Total em Devoluções R$</td>
            <td style="text-align: right; line-height: 8px; font-weight: bold; font-size: 11px; background-color: #corAtual#; padding-right: 20px;">#subtotaldevolucoes#</td>
            </tr>
            <tr style="line-height: 8px;">
            <td style="line-height: 8px; background-color: #corAtual#"></td>
            <td style="line-height: 8px; background-color: #corAtual#"></td>
            <td style="text-align: right; line-height: 8px; font-weight: bold; font-size: 11px; background-color: #corAtual#;">Total em Descontos R$</td>
            <td style="text-align: right; line-height: 8px; font-weight: bold; font-size: 11px; background-color: #corAtual#; padding-right: 20px;">#subtotaldescontos#</td>
            </tr>            
            <tr style="line-height: 8px;">
            <td style="line-height: 8px; background-color: #corAtual#"></td>
            <td style="line-height: 8px; background-color: #corAtual#"></td>
            <td style="text-align: right; line-height: 8px; font-weight: bold; font-size: 11px; background-color: #corAtual#;">Total em Créditos R$</td>
            <td style="text-align: right; line-height: 8px; font-weight: bold; font-size: 11px; background-color: #corAtual#; padding-right: 20px;">#subtotalcreditos#</td>
            </tr>
            <tr style="line-height: 8px;">
            <td style="line-height: 8px; background-color: #corAtual#"></td>
            <td style="line-height: 8px; background-color: #corAtual#"></td>
            <td style="text-align: right; line-height: 8px; font-weight: bold; font-size: 13px; background-color: #corAtual#;">Total Geral R$</td>
            <td style="text-align: right; line-height: 8px; font-weight: bold; font-size: 13px; background-color: #corAtual#; padding-right: 20px;">#subtotalgeral#</td>
            </tr>
         </table>`;

        let _linhaTopMeiosPagamentoCartao = `
         <table class="table" style="background-color: #F2F2F2;">
          <tr style="line-height: 8px; height: 8px;">
           <th scope="col" style="border: none; font-weight: normal; font-size: 10px;"><img src=${LogoRedeItau}  width="55" height="auto"></img></th>
           <th scope="col" style="border: none; font-size: 10px; line-height: 5px; vertical-align: top;"></th>
           <th scope="col" style="border: none; font-size: 10px; line-height: 5px; vertical-align: top;"></th>
           <th scope="col" style="border: none; font-size: 10px; line-height: 5px; vertical-align: top; padding-top: 14px;">VIA DO CLIENTE</th>
          </tr>
          <tr style="line-height: 8px; height: 8px; padding: 0;">
           <th scope="col" style="border: none; font-weight: bold; font-size: 11px; padding: 0;">NAFIL AUTO PECAS</img></th>
           <th scope="col" style="border: none;"></th>
           <th scope="col" style="border: none;"></th>
           <th scope="col" style="border: none;"></th>
          </tr>
          <tr style="line-height: 8px; height: 8px; padding: 0;">
           <th scope="col" style="border: none; font-weight: normal; font-size: 10px; padding: 0;">CNPJ</img></th>
           <th scope="col" style="border: none;"></th>
           <th scope="col" style="border: none;"></th>
           <th scope="col" style="border: none; font-size: 10px; text-align: right; padding: 0;">32.516.544/0001-05</th>
          </tr>
          <tr style="line-height: 8px; height: 8px; padding: 0;">
          <th scope="col" style="font-weight: normal; font-size: 10px; border-bottom: 1px solid black; padding: 0;">Nº estabelecimento:</th>
          <th scope="col" style="border-bottom: 1px solid black;"></th>
          <th scope="col" style="border-bottom: 1px solid black;"></th>
          <th scope="col" style="border-bottom: 1px solid black; font-size: 10px; text-align: right; padding: 0;">78458234</th>
         </tr>
         <tr style="line-height: 8px; height: 8px; padding: 0;">
          <th scope="col" style="border: none; font-weight: bold; font-size: 11px; padding-top: 6px;">VALOR DA VENDA:</th>
          <th scope="col" style="border: none; padding: 0;"></th>
          <th scope="col" style="border: none; padding: 0;"></th>
          <th scope="col" style="border: none; font-weight: bold; font-size: 11px; text-align: right; padding-top: 6px;">R$ #cartaoValorTotalPagamento#</th>
         </tr>
         <tr style="line-height: 8px; height: 8px; padding: 0;">
          <th scope="col" colspan="4" style="border: none; font-weight: bold; font-size: 11px; padding: 0; padding-left: 7px;">#cartaoEspecie#</th>
         </tr>
         <tr style="line-height: 8px; height: 8px; padding-top: 15px;">
          <th scope="col" style="border: none; font-weight: bold; font-size: 10px; padding: 0; padding-top: 11px;">parcelas:</th>
          <th scope="col" style="border: none;"></th>
          <th scope="col" style="border: none;"></th>
          <th scope="col" style="border: none; font-weight: bold; font-size: 10px; text-align: right; padding: 0; padding-top: 11px;">#cartaoNumeroParcelas#</th>
         </tr>
         <tr style="line-height: 8px; height: 8px; padding-top: 5px;">
         <th scope="col" style="border: none; font-weight: bold; font-size: 10px; padding: 0; padding-top: 5px;">bandeira:</th>
         <th scope="col" style="border: none; font-weight: bold; font-size: 10px; padding: 0; padding-top: 5px;"></th>
         <th scope="col" style="border: none; font-weight: bold; font-size: 10px; padding: 0; padding-top: 5px;"></th>
         <th scope="col" style="border: none; font-weight: bold; font-size: 10px; padding: 0; padding-top: 5px; text-align: right;">#cartaoBandeira#</th>
        </tr>
        <tr style="line-height: 8px; height: 8px; padding-top: 5px;">
         <th scope="col" style="border: none; font-weight: bold; font-size: 10px; padding: 0; padding-top: 5px;">número do cartão:</th>
         <th scope="col" style="border: none; font-weight: bold; font-size: 10px; padding: 0; padding-top: 5px;"></th>
         <th scope="col" style="border: none; font-weight: bold; font-size: 10px; padding: 0; padding-top: 5px;"></th>
         <th scope="col" style="border: none; font-weight: bold; font-size: 10px; padding: 0; padding-top: 5px; text-align: right;">#cartaoNumeroDoCartao#</th>
        </tr>
        <tr style="line-height: 16px; height: 16px; vertical-align: top;">
        <th scope="col" style="border: none; font-weight: bold; font-size: 10px; padding: 0;">CV (NSU):</th>
        <th scope="col" style="border: none;"></th>
        <th scope="col" style="border: none;"></th>
        <th scope="col" style="border: none; font-weight: bold; font-size: 10px; padding: 0; text-align: right;">#cartaoNSU#</th>
       </tr>
       <tr style="line-height: 20px; height: 20px; padding: 0; border-top: 1px solid black; border-bottom: 1px solid black;">       
       <th scope="col" style="border: none; font-weight: bold; font-size: 10px; padding: 0;">Data:</th>
       <th scope="col" style="border: none;"></th>
       <th scope="col" style="border: none;"></th>
       <th scope="col" style="border: none; font-weight: bold; font-size: 10px; text-align: right; padding: 0;">#dataTransacaoCartao#</th>
      </tr style="line-height: 5px; height: 5px; padding: 0;">
      <tr style="border-top: 1px solid black;">       
       <th scope="col" style="font-weight: bold; font-size: 10px;">status da venda:</th>
       <th scope="col"></th>
       <th scope="col"></th>
       <th scope="col" style="font-weight: bold; font-size: 10px; text-align: right;">#statusTransacaoCartao#</th>
      </tr>`;


        let _linhaTopMeiosPagamentoOutros = `
         <table class="table" style="background-color: #F2F2F2;">          
          <tr style="line-height: 8px; height: 8px; padding: 0;">
           <th scope="col" style="border: none; font-weight: bold; font-size: 11px; padding: 0;">#EspecieDoPagamentoTipo#</th>
           <th scope="col" style="border: none; font-weight: bold; font-size: 11px; padding: 0;">#EspecieDoPagamentoVencimento#</th>
           <th scope="col" style="border: none; font-weight: bold; font-size: 11px; padding: 0;">#EspecieDoPagamentoValor#</th>
           <th scope="col" style="border: none; font-weight: bold; font-size: 11px; padding: 0;"></th>
          </tr>`;

        let _index = 0;
        let _bgcolor = "#F2F2F2";
        let _subtotalNota = 0.00;
        let _registroAtual = 0.00;
        let _totalGeralCompras = satonImpressaoFator.subtotal;
        let _totalGeralDevolucoes = satonImpressaoFator.devolucao;
        let _totalGeralCreditos = satonImpressaoFator.credito;
        let _totalGeralDescontos = satonImpressaoFator.desconto;
        let _totalGeralPagamentos = satonImpressaoFator.total;

        _satonImpressaoItens.forEach((item) => {
            if (_index == 0) {
                _impressaoTop = _impressaoTop.replace("#ProcessoID#", item.processo + "-" + item.processo_loja).replace("#ProcessoDia#", formatarDataHora(satonImpressaoFator.data, 6)).replace("#ProcessoItens#", _satonImpressaoItens.length + (_satonImpressaoItens.length > 1 ? " Itens" : " Item"));
            }
            if (_registroAtual == item.id_venda + "-" + item.id_venda_loja) {
                _linhas += _linhaItens.replace("#quantidade#", (item.quantidade <= 0 ? "" : numberWithCommas(item.quantidade))).replace("#codigo#", (item.codigo <= 0 ? "" : item.codigo)).replace("#descricao#", item.descricao).replace("#total#", numberWithCommas(item.especie == 2 ? (item.unitario * item.quantidade) * -1 : (item.unitario * item.quantidade))).replaceAll("#corAtual#", _bgcolor).replaceAll("#fontColor#", (item.especie == 2 ? "red" : "black"));
                _subtotalNota += (item.especie == 2 ? (item.unitario * item.quantidade) * -1 : (item.unitario * item.quantidade));
                if ((_index + 1) < satonOriginal.length && _registroAtual != satonOriginal[((_index + 1) < satonOriginal.length ? _index + 1 : _index)].id_venda + "-" + satonOriginal[((_index + 1) < satonOriginal.length ? _index + 1 : _index)].id_venda_loja) {
                    _linhas += _linhaItensTotal.replace("#subtotal#", numberWithCommas(_subtotalNota)).replaceAll("#corAtual#", _bgcolor);
                    _bgcolor = (_bgcolor == "#F2F2F2" ? "#FFFFFF" : "#F2F2F2");
                    // if (item.especie == 1){
                    //     _totalGeralCompras += _subtotalNota;
                    // }
                    // if (item.especie == 2){
                    //     _totalGeralDevolucoes += _subtotalNota;
                    // }
                    // if (item.especie == 3){
                    //     _totalGeralCreditos += _subtotalNota;
                    // }
                    _subtotalNota = 0.00;
                }
            }
            else {
                _subtotalNota = _subtotalNota + (item.especie == 2 ? (item.unitario * item.quantidade) * -1 : (item.unitario * item.quantidade));
                _registroAtual = item.id_venda + "-" + item.id_venda_loja;
                _linhas += _cabecalhoNota.replace("#tipoOperacao#", identificaTipoOperacaoContasFaturadas(item.especie)).replace("#dataNota#", formatarDataHora(item.data, 6)).replace("#numeroNota#", item.id_venda + "-" + item.id_venda_loja).replaceAll("#corAtual#", _bgcolor);
                _linhas += _linhaItens.replace("#quantidade#", (item.quantidade <= 0 ? "" : numberWithCommas(item.quantidade))).replace("#codigo#", (item.codigo <= 0 ? "" : item.codigo)).replace("#descricao#", item.descricao).replace("#total#", numberWithCommas(item.especie == 2 ? (item.unitario * item.quantidade) * -1 : (item.unitario * item.quantidade))).replaceAll("#corAtual#", _bgcolor).replaceAll("#fontColor#", (item.especie == 2 ? "red" : "black"));

                if ((_index + 1) < satonOriginal.length && _registroAtual != satonOriginal[((_index + 1) < satonOriginal.length ? _index + 1 : _index)].id_venda + "-" + satonOriginal[((_index + 1) < satonOriginal.length ? _index + 1 : _index)].id_venda_loja) {
                    _linhas += _linhaItensTotal.replace("#subtotal#", numberWithCommas(_subtotalNota)).replaceAll("#corAtual#", _bgcolor);
                    // if (item.especie == 1){
                    //     _totalGeralCompras += _subtotalNota;
                    // }
                    // if (item.especie == 2){
                    //     _totalGeralDevolucoes += _subtotalNota;
                    // }
                    // if (item.especie == 3){
                    //     _totalGeralCreditos += _subtotalNota;
                    // }
                    _bgcolor = (_bgcolor == "#F2F2F2" ? "#FFFFFF" : "#F2F2F2");
                    _subtotalNota = 0.00;
                }
            }
            _index++;
        });

        // FINAL ADICIONAR SOMA GERAL 
        _linhas += _linhaTotalPagamentos.replace("#subtotalprodutos#", numberWithCommas(_totalGeralCompras))
            .replace("#subtotaldevolucoes#", numberWithCommas(_totalGeralDevolucoes))
            .replace("#subtotalcreditos#", numberWithCommas(_totalGeralCreditos))
            .replace("#subtotaldescontos#", numberWithCommas(_totalGeralDescontos))
            .replace("#subtotalgeral#", numberWithCommas(_totalGeralPagamentos)).replaceAll("#corAtual#", _bgcolor);

        // FINAL ADICIONAR MEIO DE PAGAMENTO
        _satonImpressaoEspecie.forEach((item) => {
            if (item.nband == 3) // CARTÃO DE CRÉDITO
            {
                _linhaTopMeiosPagamentoCartao = _linhaTopMeiosPagamentoCartao.replace("#cartaoValorTotalPagamento#", numberWithCommas(item.valor, 2))
                    .replace("#cartaoEspecie#", (item.vezes == 1 ? "CRÉDITO À VISTA" : "CRÉDITO PARCELADO LOJA"))
                    .replace("#cartaoNumeroParcelas#", (item.vezes == 1 ? "à vista" : _satonImpressaoEspecie.vezes + " vezes"))
                    .replace("#cartaoBandeira#", item.bandeira)
                    .replace("#cartaoNumeroDoCartao#", item.cartao)
                    .replace("#cartaoNSU#", item.nsu)
                    .replace("#dataTransacaoCartao#", formatarDataHora(item.data, 6))
                    .replace("#statusTransacaoCartao#", item.resposta);
            }
            else if (item.nband == 15) // BOLETO BANCÁRIO
            {


            }
            else if (item.nband == 17) // PIX
            {
                _linhaTopMeiosPagamentoOutros = _linhaTopMeiosPagamentoOutros.replace("#EspecieDoPagamentoTipo#", item.tipo)
                    .replace("#EspecieDoPagamentoVencimento#", (item.pix_validade != null && item.pix_recebido == null ? formatarDataHora(item.pix_validade, 6) : ""))
                    .replace("#EspecieDoPagamentoValor#", numberWithCommas(item.valor, 2));
            }
        });

        // LIMPA CASO ALGUM CAMPO NÃO ESTEJA PREENCHIDO
        _linhaTopMeiosPagamentoOutros = _linhaTopMeiosPagamentoOutros.replaceAll("#EspecieDoPagamentoTipo#", "")
            .replaceAll("#EspecieDoPagamentoVencimento#", "")
            .replaceAll("#EspecieDoPagamentoValor#", "");

        _linhaTopMeiosPagamentoCartao = _linhaTopMeiosPagamentoCartao.replaceAll("#cartaoValorTotalPagamento#", "")
            .replaceAll("#cartaoEspecie#", "")
            .replaceAll("#cartaoNumeroParcelas#", "")
            .replaceAll("#cartaoBandeira#", "")
            .replaceAll("#cartaoNumeroDoCartao#", "")
            .replaceAll("#cartaoNSU#", "")
            .replaceAll("#dataTransacaoCartao#", "")
            .replaceAll("#statusTransacaoCartao#", "");

        imprimirDoc = (_impressaoTop + _linhas + _linhaTopMeiosPagamentoCartao + _linhaTopMeiosPagamentoOutros + _impressaoRodape);

        console.log("PASSEI A ", imprimirDoc);

        //     //   _vtVendasPag = _processosSelecionados.map((s) => Number(s.total)).reduce((antes, atual) => antes + atual, 0);
        //     //   setValorTotalVendasPagamentos(
        //     //     _vtVendasPag
        //     //   );
        //     //   setQuantidadeTotalVendasPagamentos(_fVendas.length);
        //     // return imprimirDoc;
        return imprimirDoc;
    };

    function PesquisarCPF_CNPJ(value, event) {
        // Teclas Aceitas
        if (event != null && event.key == "Backspace") {
            if (value.length == 12) {
                value = value.substr(0, 11);
                return;
            }
            return;
        }
        else {
            if (event != null && (event.ctrlKey == true && (event.key != "v" || event.key != "V")) && event.key != "Delete" && event.key != "Tab" && event.key != "ArrowLeft" && event.key != "ArrowRight" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                if (value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length != 11 || value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length != 14) {
                    return;
                }
            }
        }
        // CNPJ
        if (value != null && value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length >= 14) {
            var objDigitados = document.getElementById("cartaoCPF");
            var digitados = objDigitados.value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");
            if (digitados != null) {
                objDigitados.value = digitados.substr(0, 2) + "." + digitados.substr(2, 3) + "." + digitados.substr(5, 3) + "/" + digitados.substr(8, 4) + "-" + digitados.substr(12, 2);
                setCpf_cnpjError("");
            }
        }
        // CPF
        else {
            if (value != null && value.indexOf('.') == -1 && value.replaceAll("-", "").length == 3 || value != null && value.replaceAll("-", "").length == 7) {
                var antes = document.getElementById("cartaoCPF");
                antes.value = value + ".";
                setCpf_cnpjError("");
            }
            if (value != null && value.replaceAll("-", "").length == 11 && value.indexOf('-') == -1) {
                var antes = document.getElementById("cartaoCPF");
                antes.value = value + "-";
                setCpf_cnpjError("");
            }
            if (value != null && value.replaceAll("-", "").length < 5 && value.indexOf('-') != -1) {
                var antes = document.getElementById("cepFrete");
                antes.value = value.replace("-", "");
                setCpf_cnpjError("");
            }
            if (value != null && value.indexOf('.') == -1 && value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length == 11) {
                var objDigitados = document.getElementById("cartaoCPF");
                var digitados = objDigitados.value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");
                if (digitados != null) {
                    objDigitados.value = digitados.substr(0, 3) + "." + digitados.substr(3, 3) + "." + digitados.substr(6, 3) + "-" + digitados.substr(9, 2);
                    setCpf_cnpjError("");
                }
            }
        }
        // Finalizado Digitação Vou Ferificar os Valores Digitados
        if (value != null) {
            if (validaCpfCnpj(value) == false) {
                if (value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length == 11) {
                    setCpf_cnpjError("CPF Inválido");
                }
                if (value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length == 14) {
                    setCpf_cnpjError("CNPJ Inválido");
                }
            }
            else {
                setCpf_cnpjError("");
            }
        }
    }


    function TestarCVV(value, event) {
        // Teclas Aceitas
        if (event != null && event.key == "Backspace") {
            setVencimentoError("");
            return;
        }
        else {
            if (event != null && (event.ctrlKey == true && (event.key != "v" || event.key != "V")) && event.key != "Delete" && event.key != "Tab" && event.key != "ArrowLeft" && event.key != "ArrowRight" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                setVencimentoError("");
                return;
            }
        }
        if (value != null) {
            var objDigitados = document.getElementById("cartaoCVV");
            var digitados = objDigitados.value;
            if (digitados != null) {
                // Testar CVV
                if (objDigitados.value != null && objDigitados.value.length < 3) {
                    setVencimentoError("CVV - Código de Segurança Inválido");
                    return;
                }
                else {
                    setVencimentoError("");
                    setCartaoDigitadoCVV(digitados);
                }
            }
        }
    }

    function TestarNomeCartao(value, event) {
        // Teclas Aceitas
        if (event != null && event.key == "Backspace") {
            setCartaoNomeError("");
            return;
        }
        else {
            if (event != null && (event.ctrlKey == true && (event.key != "v" || event.key != "V")) && event.key != "Delete" && event.key != "Tab" && event.key != "ArrowLeft" && event.key != "ArrowRight" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                setCartaoNomeError("");
                return;
            }
        }
        if (value != null) {
            var objDigitados = document.getElementById("cartaoNome");
            var digitados = objDigitados.value;
            if (digitados != null) {
                // Testar CVV
                if (objDigitados.value != null && objDigitados.value.length < 2) {
                    setCartaoNomeError("Nome do Portador Inválido");
                    return;
                }
                else {
                    setCartaoNomeError("");
                    setCartaoDigitadoNome(digitados);
                }
            }
        }
    }

    function TestarNumeroCartaoCredito(value, event) {
        if (event != null && event.key == "Backspace") {
            setCartaoNumeroError("");
            return;
        }
        else {
            if (event != null && (event.ctrlKey == true && (event.key != "v" || event.key != "V")) && event.key != "Delete" && event.key != "Tab" && event.key != "ArrowLeft" && event.key != "ArrowRight" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                if (value.replaceAll(".", "").length != 4) {
                    setCartaoNumeroError("");
                    return;
                }
            }
        }
        if (value != null) {
            var objDigitados = document.getElementById("cartaoNumero");
            var digitados = objDigitados.value.replaceAll(" ", "").replace(/[^0-9]/, '');
            if (digitados != null) { // && digitados.length > 4) {
                var _bloco01 = digitados.substr(0, 4);
                var _bloco02 = (digitados.length > 4 ? digitados.substr(4, 4) : "");
                var _bloco03 = (digitados.length > 8 ? digitados.substr(8, 4) : "");
                var _bloco04 = (digitados.length > 12 ? digitados.substr(12, 4) : "");;
                objDigitados.value = _bloco01 + (_bloco02 != "" ? " " + _bloco02 : "") + (_bloco03 != "" ? " " + _bloco03 : "") + (_bloco04 != "" ? " " + _bloco04 : "");
                setCartaoNumeroError("");
            }
            if (digitados != null && digitados.length >= 15) {
                setCartaoSelecionado(CartaoCreditoTipo(digitados));
                setCartaoDigitadoNumero(digitados);
            }
        }
    }

    function TestarValidadeCartaoCredito(value, event) {
        // Teclas Aceitas
        if (event != null && event.key == "Backspace") {
            setVencimentoError("");
            return;
        }
        else {
            if (event != null && (event.ctrlKey == true && (event.key != "v" || event.key != "V")) && event.key != "Delete" && event.key != "Tab" && event.key != "ArrowLeft" && event.key != "ArrowRight" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                if (value.replaceAll("/", "").replaceAll("-", "").replaceAll(" ", "").length != 4) {
                    setVencimentoError("");
                    return;
                }
            }
        }
        if (value != null) {
            var objDigitados = document.getElementById("cartaoValidade");
            var digitados = objDigitados.value.replaceAll("/", "").replaceAll("-", "");
            if (digitados != null) {
                objDigitados.value = (digitados.length >= 2 ? digitados.substr(0, 2) + "/" : digitados) + (digitados.length > 2 ? digitados.substr(2, digitados.length - 2) : "");

                // Testar Mês
                if (objDigitados.value != null && objDigitados.value.length >= 2) {
                    if (objDigitados.value.substr(0, 2) <= '00' || objDigitados.value.substr(0, 2) >= '13') {
                        setVencimentoError("Mês de Vencimento Inválido");
                        return;
                    }
                    else {
                        setVencimentoError("");
                    }
                }

                // Testar Ano
                if (objDigitados.value != null && objDigitados.value.length == 5) {
                    var anoAtual = new Date().getFullYear().toString();
                    if (objDigitados.value.substr(3, 2) <= '00' || anoAtual != null && objDigitados.value.substr(3, 2) < anoAtual.substring(2, 4)) {
                        setVencimentoError("Ano de Vencimento Inválido");
                        return;
                    } else {
                        setVencimentoError("");
                    }
                }
                setCartaoDigitadoValidade(objDigitados.value);
            }
        }
    }

    const handleChangeComboParcelamentos = (event) => {
        const {
            target: { value },
        } = event;
        let _numeroParcelasSelecionada = Number(event?.target?.value.substr(0, event?.target?.value.indexOf("x")) ?? '0');
        setPagamentoNumeroParcelas(_numeroParcelasSelecionada);
        setConfirmouCancelamento(true);
        setPagamentoOpcaoSelecionada(
            // On autofill we get a stringified value.
            //typeof value === 'string' ? value.split(',') : value,
            typeof value === 'string' ? value : value,
        );
        setPagamentoNumeroParcelasError("");
    };

    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 48 * 4.5 + 8,
                width: 250,
            },
        },
    };

    const useStylesDatePicker = makeStyles({
        root: {
            "& .MuiInputBase-root": {
                padding: 2,
                paddingLeft: 4,
                "& .MuiButtonBase-root": {
                    padding: 6,
                    paddingLeft: 4
                },
                "& .MuiInputBase-input": {
                    padding: 6,
                    paddingLeft: 4
                }
            }
        }
    });

    const classesDatePicker = useStylesDatePicker();

    const handleDateChange = (newValue) => {
        setDates(newValue);
    };

    const DevolucaoSucess = (mensagem) => toast.success(mensagem,
        {
            position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000
        })

    const DevolucaoErro = (mensagem) => toast.error(mensagem,
        {
            position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000
        })

    const toastMensagemError = (message) => toast.error(message,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

    const toastErroApiNaoResponde = () => toast.error("Ops, Alguma Coisa Errada com Nosso Servidor!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 3000 });

    const toastMarcarItensParaImpressao = () => toast.error("Selecione Algum Item Para Impressão!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });


    useEffect(() => {
        setUsuarioLogado(sessionStorage.getItem("id_loja_usuario"));
        let usuarioComprasFaturado = sessionStorage.getItem("usuario_compras_faturado");
        if (usuarioComprasFaturado != 1) {
            toastMensagemError("SOMENTE PARA CLIENTES FATURADOS!");
        }
        TipoPagamento(1);
        setNomeUsuarioLogado(identificacaoNomeUsuarioLogado());
        setUsuarioLogado(identificacaoUsuarioLogado());
        setNomeFullRazaoSocialLogado(identificacaoRazaoSocialUsuarioLogado());
        BuscarDuplicatas(identificacaoUsuarioLogado());
        BuscarChequesDevolvidos(identificacaoUsuarioLogado());
        BuscarComprasFaturadas(identificacaoUsuarioLogado());
        RecalcularTotais();
    }, []);

    useEffect(() => {
        BuscarDuplicatas(identificacaoUsuarioLogado());
        BuscarChequesDevolvidos(identificacaoUsuarioLogado());
        BuscarComprasFaturadas(identificacaoUsuarioLogado());
        checarCalculoPagamentos();
        RecalcularTotais();
    }, [switchAbertas]);


    // useEffect(() => {
    //     BuscarDuplicatas(identificacaoUsuarioLogado());
    //     BuscarChequesDevolvidos(identificacaoUsuarioLogado());
    //     BuscarComprasFaturadas(identificacaoUsuarioLogado());
    //     checarCalculoPagamentos();
    //     RecalcularTotais();
    // }, [selectionModelDevolucoes, switchAbertas, valorTotalVendas, valorTotalDevolucoes, valorTotalCreditos, valorTotalDuplicatas, valorTotalChequesDevolvidos, valorDescontosPagamentos, meuFormaPagamentoTipo, valorTotalVendasPagamentos]);        
    //}, [selectionModel, selectionModelDevolucoes, switchAbertas, valorTotalVendas, valorTotalDevolucoes, valorTotalCreditos, valorTotalDuplicatas, valorTotalChequesDevolvidos, valorDescontosPagamentos, meuFormaPagamentoTipo, valorTotalVendasPagamentos]);

    // useEffect(() => {
    //     // BuscarDuplicatas(identificacaoUsuarioLogado());
    //     // BuscarChequesDevolvidos(identificacaoUsuarioLogado());
    //     // BuscarComprasFaturadas(identificacaoUsuarioLogado());
    //     //checarCalculoPagamentos();
    //     //RecalcularTotais();
    // }, [selectionModel]);

    useEffect(() => {
        let retornoHTMLImpressao;
        const _retAPI = async () => {

            // console.log("CRISA ", satonImpressaoItens);

            const _cabecalho = "<!DOCTYPE html><html><head><title>NAFIL Extrato</title></head><body><table width=\"99%\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\">"; 
            const _cabecalhoDados = "<tr><td width=\"10%\"><img src={LogoNameOneLine}</td><td width=\"90%\"> Processo: #processo#</td><td>Data: #data#</td><td>Contendo: #contendo#</td></tr>"; 
            const _rodape = "</body></html>";
            
            console.log("CRISUX");

            console.log("CRISU ", _cabecalho + _cabecalhoDados + _rodape);




            if (satonImpressaoItens != null && satonImpressaoItens.length > 0) {
                //setConteudoParaImpressao("");
                retornoHTMLImpressao = await GerarImpressao(satonImpressaoItens, satonImpressaoEspecie);
                // setConteudoParaImpressao(retornoHTMLImpressao);                        
                //setSatonImpressaoEspecie([]);
                //setSatonImpressaoFator([]);

                // CRIAR HTML PARA IMPRESSÃO - INÍCIO
                // const _cabecalho = "<!DOCTYPE html><html><head><title>NAFIL Extrato</title></head><body><table width=\"99%\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\">"; 
                // const _cabecalhoDados = "<tr><td width=\"10%\"><img src={LogoNameOneLine}</td><td width=\"90%\"> Processo: #processo#</td><td>Data: #data#</td><td>Contendo: #contendo#</td></tr>"; 
                // const _rodape = "</body></html>";
                
                // console.log("CRISA ", _cabecalho + _cabecalhoDados + _rodape);

                // CRIAR HTML PARA IMPRESSÃO - FINAL

                console.log("CRISY ", retornoHTMLImpressao, satonImpressaoItens, satonImpressaoEspecie);


                const printWindow = window.open('', '_blank', 'height=600,width=800');
                printWindow.document.open();
                printWindow.document.write(retornoHTMLImpressao);
                printWindow.document.close();
                printWindow.print();
                // setConteudoParaImpressao(null); 
                setSatonImpressaoEspecie([]);
                setSatonImpressaoFator([]);
                setSatonImpressaoItens([]);

                console.log("_retAPI T ", retornoHTMLImpressao);
            }
        }
        _retAPI();
    }, [iniciarImpressao]);


    useEffect(() => {
        // if (conteudoParaImpressao != null && conteudoParaImpressao.length > 0) {
        //     const printWindow = window.open('', '_blank', 'height=600,width=800');
        //     printWindow.document.open();
        //     printWindow.document.write(conteudoParaImpressao);
        //     printWindow.document.close();
        //     printWindow.print();
        //     setConteudoParaImpressao(null);  
        // }
    }, [conteudoParaImpressao]);

    const createGetExtratos = async (satonImpressaoProcessoId, satonImpressaoProcessoIdLoja) => {
        let usuario_logado = identificacaoUsuarioLogado();
        let _userId = usuario_logado.split('_')[0];
        let _userIdloja = usuario_logado.split('_')[1];
        let _processoId = satonImpressaoProcessoId;
        let _processoIdLoja = satonImpressaoProcessoIdLoja;

        if (_processoId <= 0) {
            return false;
        }
        let dados = null;
        try {
            dados = await api.get(`Saton/ExtratoItens/${_userId}/${_userIdloja}/${_processoId}/${_processoIdLoja}`)
                .then((response) => {
                    // setSatonImpressaoItens(response?.data.satonParcial);
                    // setSatonImpressaoEspecie(response?.data.especieParcial);
                    // setSatonImpressaoFator(response?.data.fatorParcial);
                    return response?.data;
                })
                .then((respons) => {
                    // setSatonImpressaoItens(response?.satonParcial);
                    // setSatonImpressaoEspecie(response?.especieParcial);
                    // setSatonImpressaoFator(response?.fatorParcial);                    
                    return respons;
                });
        } catch (e) {
            // setSatonImpressaoEspecie([]);
            // setSatonImpressaoFator([]);
            // setSatonImpressaoItens([]);
            return null;
            //            return e;
        };
        // setSatonImpressaoEspecie(dados?.especieParcial);
        // setSatonImpressaoFator(dados?.fatorParcial);                    
        // setSatonImpressaoItens(dados?.satonParcial);
        return dados;
    }

    const highestData = saton.reduce((previous, current) => {
        return current.data > previous.data ? current : previous;
    }, 0);

    const ShowModalMeusCheques = (event) => {
        setShowModalMeusCheques(true);
    }

    const handleCloseModalMeusCheques = () => {
        setOpenMeusCheques(false);
    }

    const modalStyle = {
        position: 'absolute',
        top: '10%',
        left: '10%',
        right: "10%",
        overflow: 'scroll',
        height: '100%',
        display: 'block',
        bgcolor: 'background.paper',
        boxShadow: 24
    }

    const fazerBaixaSaton = {
        id_cliente: 0,
        id_cliente_loja: 0,
        tipo_pagamento: 0,
        valor_total_compras: 0.00,
        valor_total_devolucoes: 0.00,
        valor_total_creditos: 0.00,
        valor_total_descontos: 0.00,
        valor_total_receber: 0.00,
        saton: [],
        especie: [],
        fator: [],
        cartaoNumero: "",
        cartaoValidade: "",
        cartaoCVV: "",
        cartaoNome: "",
        cartaoParcelas: 1,
        cartaoModelo: 0,
        cartaoErro: 0,
        cartaoErroDescricao: "",
        pixCopiaCola: "",
        usuarioLogado: "",
        nomeUsuarioLogado: "",
        operacaoExecutadaSucesso: 0
    };

    const [preVendaState, setPreVendaState] = useState({});
    const [preVendasItem, setPreVendasItem] = useState([]);
    const [especieItem, setEspecieItem] = useState({
        especie_id: 0,
        especie_loja: 998,  // 999
        venda_id: 0,
        venda_loja: 998,  // 999
        data: "1997-01-01T00:00:00",
        tipo: 0,
        valor: 0.00,
        vezes: 0,
        usuario: 0,
        caixa: 0,
        retorno: null,
        codctf: null,
        respdll: null,
        operadora_cnpj: null,
        cartao: "",
        bandeira: "",
        codautor: "",
        retautor: "",
        nsu: "",
        nsuautor: "",
        aprovacao: "",
        van: "",
        operadora: "",
        autorizadora: "",
        transacao: "1997-01-01 00:00:00",
        modo: "",
        resposta: "",
        nband: 0,
        disk: 1,
        finalizado: 0,
        tipo_integracao: 0,
        tid: "",
        presencial: 0,
        pix_txid: null,
        pix_validade: null,
        pix_recebido: null,
        pix_location: null,
        ordem: 0
    });

    const [pedidosWebClass, setPedidosWebClass] = useState({
        preVendas: {},
        // preVendasItensComMarcaClass: [],
        preVendasItens: [],
        especie: [],
        creditos: [],
        cartaoNumero: "",
        cartaoValidade: "",
        cartaoCVV: "",
        cartaoNome: "",
        idModeloTransporte: -1,
        pixCopiaCola: "",
        usuarioLogado: "",
        nomeUsuarioLogado: ""
    });

    // Verifica Meio de Pagamento e Analisa se Está Todos Dados Preenchidos
    var listaItens = [];
    var listaEspecie = [];
    var listaPreVendasItensComMarcaClass = [];
    let _preVendasItem = preVendasItem;
    let _especie = especieItem;
    //let _notaAgrupada = "";


    let _notaAgrupada = 0; //(saton != null && saton.length > 0 && saton[0].id_venda > 0 ? saton[0].id_venda  + "-" + saton[0].id_venda_loja: "");
    let _corNotaAgrupada = "branco";

    // Efetuar Pagamento
    const SalvarEfetuarPagamento = () => {


        console.log("CHEGUEI A");

        if (quantidadeTotalVendasPagamentos <= 0 && quantidadeTotalCreditosPagamentos <= 0 && quantidadeTotalDevolucoesPagamentos <= 0) {
            toastMensagemError("SELECIONE ALGUM ITEM PARA PAGAMENTOS!");
            return;
        }
        console.log("CHEGUEI B");

        if (meuFormaPagamentoTipo != 1 && meuFormaPagamentoTipo != 2 && meuFormaPagamentoTipo != 3) {
            toastMensagemError("SELECIONE A FORMA DE PAGAMENTO!");
            return;
        }

        console.log("CHEGUEI C");

        let _usuarioLogado = usuarioLogado.split('_');
        if (_usuarioLogado == null || _usuarioLogado.length != 2) {
            toastMensagemError("LOGIN INVÁLIDO!");
            return;
        }

        console.log("CHEGUEI D");

        fazerBaixaSaton.id_cliente = Number(_usuarioLogado[0]);
        fazerBaixaSaton.id_cliente_loja = Number(_usuarioLogado[1]);
        fazerBaixaSaton.valor_total_compras = Number(valorTotalVendasPagamentos).toFixed(2);
        fazerBaixaSaton.valor_total_devolucoes = Number(valorTotalDevolucoesPagamentos).toFixed(2);
        fazerBaixaSaton.valor_total_creditos = Number(valorTotalCreditosPagamentos).toFixed(2);
        fazerBaixaSaton.valor_total_descontos = Number(valorDescontosPagamentos).toFixed(2);
        fazerBaixaSaton.valor_total_receber = Number(totalGeralPagamentos).toFixed(2);

        // PIX
        if (meuFormaPagamentoTipo === 1) {
            console.log("CHEGUEI E1", meuFormaPagamentoTipo === 3);
            fazerBaixaSaton.tipo_pagamento = 1;
            // _especie.especie_id = 0;
            // _especie.especie_loja = 998;  // 999
            // _especie.venda_id = 0;
            // _especie.venda_loja = 998; // 999
            // _especie.data = '1997-01-01T00:00:00';
            // _especie.tipo = 'PIX';
            // _especie.valor = totalGeralPagamentos ?? 0.00;
            // _especie.vezes = 1;
            // _especie.usuario = 0;
            // _especie.caixa = 0;
            // _especie.retorno = '';
            // _especie.codctf = '';
            // _especie.respdll = '';
            // _especie.operadora_cnpj = '';
            // _especie.cartao = '';
            // _especie.bandeira = '';
            // _especie.codautor = '';
            // _especie.retautor = '';
            // _especie.nsu = '';
            // _especie.nsuautor = '';
            // _especie.aprovacao = '';
            // _especie.van = '';
            // _especie.operadora = '';
            // _especie.autorizadora = '';
            // _especie.transacao = '1997-01-01T00:00:00';
            // _especie.modo = '';
            // _especie.resposta = '';
            // _especie.nband = 17;  // 17 - 'PIX PAGAMENTO INSTANTÂNEO' tabela 'tipos_pagamentos'
            // _especie.disk = 0;
            // _especie.finalizado = 0;
            // _especie.tipo_integracao = 2;
            // _especie.presencial = 0;
            // _especie.ordem = 1;
            // _especie.processo_id = 0;
            // _especie.processo_id_loja = 0;
            // listaEspecie.push(_especie);
        }
        // BOLETO
        if (meuFormaPagamentoTipo === 2) {
            console.log("CHEGUEI E2", meuFormaPagamentoTipo === 3);
            fazerBaixaSaton.tipo_pagamento = 2;
        }

        // CARTÃO
        if (meuFormaPagamentoTipo === 3) {
            setConfirmouCancelamento(true);
            if (VerificarDigitacaoCartoes() == false) {
                console.log("VAACA ");
                return;
            }

            fazerBaixaSaton.tipo_pagamento = 3;
            fazerBaixaSaton.cartaoNumero = "MTz547kaAyyRP9xooknjJIbsewYSchF" + Buffer.from(cartaoDigitadoNumero).toString('base64');
            fazerBaixaSaton.cartaoValidade = "EvTIWqQ57d698BcmnIO65743aXkJ8511Dai" + Buffer.from(cartaoDigitadoValidade).toString('base64');
            fazerBaixaSaton.cartaoCVV = "GhiOoB1657pR8dSiexW25711Tr16unMS" + Buffer.from(cartaoDigitadoCVV).toString('base64');
            fazerBaixaSaton.cartaoNome = "cHJ32pdmF0ZSBzdGF0aWAMgcXmVhZG9ubSQHkgSHR0cESAXNsaWVudCBfQ2xpZ324W50ID0gbmV3I25OpEh0dHBDbGllSKlBvbnQoKTs" + Buffer.from(cartaoDigitadoNome.toUpperCase()).toString('base64');
            fazerBaixaSaton.cartaoParcelas = pagamentoNumeroParcelas;
            fazerBaixaSaton.cartaoModelo = (3 + cartaoTipoCartao);
            // _especie.especie_id = 0;
            // _especie.especie_loja = 998; // 999
            // _especie.venda_id = 0;
            // _especie.venda_loja = 998; // 999
            // _especie.data = '1997-01-01T00:00:00';
            // _especie.tipo = ((3 + cartaoTipoCartao) == 4 ? 'CARTÃO DE DÉBITO' : 'CARTÃO DE CRÉDITO');
            // _especie.valor = totalGeral ?? 0.00;
            // _especie.vezes = pagamentoNumeroParcelas ?? 1;
            // _especie.usuario = 0;
            // _especie.caixa = 0;
            // _especie.retorno = '';
            // _especie.codctf = '';
            // _especie.respdll = '';
            // _especie.operadora_cnpj = '01425787000104'; // REDE CARD CNPJ OPERADORA
            // _especie.cartao = '';
            // _especie.bandeira = '';
            // _especie.codautor = '';
            // _especie.retautor = '';
            // _especie.nsu = '';
            // _especie.nsuautor = '';
            // _especie.aprovacao = '';
            // _especie.van = '';
            // _especie.operadora = '';
            // _especie.autorizadora = '';
            // _especie.transacao = '1997-01-01T00:00:00';
            // _especie.modo = '';
            // _especie.resposta = '';
            // _especie.nband = (3 + cartaoTipoCartao);  // 3 ou 4  - cartaoTipoCartao Seleciona Crédito 3 ou Débito 4
            // _especie.disk = 1;
            // _especie.finalizado = 0;
            // _especie.tipo_integracao = 2;
            // _especie.presencial = 0;
            // _especie.ordem = 1;
            // _especie.processo_id = 0;
            // _especie.processo_id_loja = 0;
            // listaEspecie.push(_especie);
        }

        selectionModel.forEach(el => {
            let newLinha = Object.assign({});
            newLinha.ids_saton = Number(el.split('-')[0]);
            newLinha.ids_saton_loja = Number(el.split('-')[1]);
            fazerBaixaSaton.saton.push(newLinha);
            newLinha = null;
        });

        console.log("POSICAO FINAL", fazerBaixaSaton);

        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        }
        // const apenasId = selectionModelDevolucoes.map((id) => id.split("-")[0]);
        // const itensDevolucao = saton.filter((objeto) =>
        //   apenasId.includes(objeto.ids_saton.toString())
        // );


        // PIX 
        if (meuFormaPagamentoTipo === 1) {

        }

        // BOLETO
        if (meuFormaPagamentoTipo === 2) {
            api.post('Saton/NotasBaixadasComBoletos', JSON.stringify(fazerBaixaSaton), config).then(res => {
                console.log("PAGOU ", res.data);
                // DevolucaoSucess(res.data);
                // setOpenDialogoDevolucoes(false);
            }).catch(erro => {
                console.log("ERROR ", erro);
                // DevolucaoErro('Erro ao Processar as devoluções ' + erro.data)
            });
        }

        // CARTÃO DE CRÉDITO / DÉBITO
        if (meuFormaPagamentoTipo === 3) {

            api.post('Saton/EfetuarPagamentoFaturado', JSON.stringify(fazerBaixaSaton), config).then(res => {
                console.log("PAGOU ", res.data);

                // DevolucaoSucess(res.data);
                // setOpenDialogoDevolucoes(false);
            }).catch(erro => {
                console.log("ERROR ", erro);
                // toastMensagemError("FALHOU: " + (erro != null && erro.me .message != null ? e))
                // DevolucaoErro('Erro ao Processar as devoluções ' + erro.data)
            });

        }
    }

    function DividirParcelamentosCartoes(jsonPracelas) {
        var _valorDasParcelas = [];
        var _valorTotal = totalGeralPagamentos; // (totalProdutos + totalFrete - totalDescontos - totalCreditos);
        setPagamentoNumeroMaximoParcelas(jsonPracelas);
        //for (let i = 1; i <= Number(pagamentoNumeroMaximoParcelas?.prestacao ?? 1); i++) {
        for (let i = 1; i <= Number(jsonPracelas?.prestacao ?? 1); i++) {
            _valorDasParcelas.push(i + ' x ' + (_valorTotal / i).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + (jsonPracelas.juros > 0 ? ' com juros' : ' sem juros'));
        }
        return (_valorDasParcelas);
    }

    // function TipoPagamento(value) {

    //   debugger;
    //   console.log("AGORA X");

    //   if (value <= 2) {
    //     setPagamentoNumeroMaximoParcelas({ prestacao: 1 });
    //     setCartaoTipoCartao(0);
    //     TelaTipoDeCartaoCreditoOuDebito(0);

    //     console.log("AGORA Z");

    //   } else {
    //     console.log("AGORA Y");
    //     api.get('Prazos/' + totalGeral).then((response) => {
    //       setPagamentoNumeroMaximoParcelas(response?.data);
    //       setCartaoTipoCartao(0);
    //       TelaTipoDeCartaoCreditoOuDebito(0);

    //       console.log("AGORA A");
    //       setPagamentoValorParcelas(DividirParcelamentosCartoes());


    //     }).catch((e) => {
    //       console.log(e);
    //     })
    //   }
    //   if (meuFormaPagamentoTipo != value) {
    //     setMeuFormaPagamentoTipo(value); // Tipo de Pagamento 1 - PIX / 2 - BOLETO / 3 - CARTÃO CRÉDITO ou DÉBITO
    //   }
    // }

    const SalvarPreDevolucao = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        }
        const apenasId = selectionModelDevolucoes.map((id) => id.split("-")[0]);
        const itensDevolucao = saton.filter((objeto) =>
            apenasId.includes(objeto.ids_saton.toString())
        );

        api.post('Clientes/Faturado/SalvarPreDevolucao', JSON.stringify(itensDevolucao), config).then(res => {
            DevolucaoSucess(res.data);
            setOpenDialogoDevolucoes(false);
        }).catch(erro => {
            DevolucaoErro('Erro ao Processar as devoluções ' + erro.data)
        })
    }

    const verificarImpossibilidadeDevolucoes = (dataCompra) => {
        const dataAtual = new Date();
        const dataBanco = new Date(dataCompra);
        const diferencaEmMilissegundos = dataAtual - dataBanco;
        const diasPassados = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);
        if (diasPassados > 30) {  // 30 DIAS LIMITE PARA DEVOLUÇÕES
            return true;
        }
        else {
            return false;
        }
    }

    function VerificarDigitacaoCartoes() {
        if (cartaoDigitadoNumero.replaceAll(" ", "").replace(/[^0-9]/, '').length < 14) {
            setCartaoNumeroError("Número do Cartão Inválido");
            console.log("VAACA 1");
            return false;
        } else {
            setCartaoNumeroError("");
        }
        if (cartaoDigitadoNome.replaceAll(" ", "").length < 8) {
            setCartaoNomeError("Nome do Portador do Cartão Inválido");
            console.log("VAACA 2");
            return false;
        } else {
            setCartaoNumeroError("");
        }
        if (cartaoDigitadoValidade.replaceAll(" ", "").replace(/[^0-9]/, '').length < 4) {
            setVencimentoError("Validade do Cartão Inválida");
            console.log("VAACA 3");
            return false;
        } else {
            setVencimentoError("");
        }
        if (cartaoDigitadoValidade.indexOf('/') == -1) {
            setVencimentoError("Ano de Vencimento Inválido");
            console.log("VAACA 4");
        }
        if (cartaoDigitadoValidade.split('/')[0] <= '00' || cartaoDigitadoValidade.split('/')[0] >= '13') {
            setVencimentoError("Mês de Vencimento Inválido");
            console.log("VAACA 5");
            return;
        }
        else {
            setVencimentoError("");
        }
        var anoAtual = new Date().getFullYear().toString();
        if (cartaoDigitadoValidade.split('/')[1] <= '00' || anoAtual != null && cartaoDigitadoValidade.split('/')[1] < anoAtual.substring(2, 4)) {
            setVencimentoError("Ano de Vencimento Inválido");
            console.log("VAACA 6");
            return;
        } else {
            setVencimentoError("");
        }
        if (cartaoDigitadoCVV.replaceAll(" ", "").replace(/[^0-9]/, '').length < 3 || cartaoDigitadoCVV.replaceAll(" ", "").replace(/[^0-9]/, '').length > 4) {
            setVencimentoError("CVV do Cartão Inválido");
            console.log("VAACA 7");
            return false;
        } else {
            setVencimentoError("");
        }
        if (pagamentoNumeroParcelas <= 0 || pagamentoNumeroParcelas > 12) {
            setPagamentoNumeroParcelasError("Selecione o Número de Parcelas Desejado");
            console.log("VAACA 8");
            return false;
        }
        else {
            setPagamentoNumeroParcelasError("");
        }
        if (confirmouCancelamento == false) {
            setConfirmouCancelamentoError("Será Necessário Marcar 'Concordo...' Pois as Lojas Físicas Estão Vendendo Simultâneamente");
            console.log("VAACA 9");
            return false;
        } else {
            setConfirmouCancelamentoError("");
        }
        console.log("CHEGUEI G1 ");
        return true;
    }


    const efetuarCalculoPagamentos = (row) => {
        let _vtVendasPag = 0.00;
        let _vtDevoluvoesPag = 0.00;
        let _vtCreditosPag = 0.00;
        let _vtDescontosPag = 0.00;

        setSelectionModel(row);  // LINHAS SELECIONADAS 

        // setSelectionModel([...selectionModel, row]);  // LINHAS SELECIONADAS 

        // TOTAL VENDAS PAGAMENTOS
        let _fVendas = saton.filter((t) => t.especie == 1 && t.processo == null).filter(function (item) {
            return row.includes(item.ids_saton.toString() + "-" + item.ids_saton_loja.toString());
        });
        _vtVendasPag = _fVendas.map((s) => Number(s.total)).reduce((antes, atual) => antes + atual, 0);
        setValorTotalVendasPagamentos(
            _vtVendasPag
        );
        setQuantidadeTotalVendasPagamentos(_fVendas.length);

        // TOTAL DESCONTOS PAGAMENTOS
        var startDate = new Date();
        startDate.setDate(startDate.getDate() - 7);  // 7 DIAS

        var _produtosPossibildadeDescontos = _fVendas.filter(a => {
            var date = new Date(a.data);
            return (date >= startDate);
        });

        setListaItensFaturadosDescontosPagamentos(_produtosPossibildadeDescontos);
        // setValorDescontosPagamentos(_produtosPossibildadeDescontos);

        let _percentualDescontoAVista = (descontoPagamentoAVista == null && Object.keys(descontoPagamentoAVista).length === 0 ? 0.00 : 1 + (descontoPagamentoAVista.juros / 100));
        let _itensParaDescontos = _produtosPossibildadeDescontos.map((s) => Number(s.total)).reduce((antes, atual) => antes + atual, 0);

        _vtDescontosPag = (descontoPagamentoAVista == null && Object.keys(descontoPagamentoAVista).length === 0 ? 0.00 :
            (_itensParaDescontos >= descontoPagamentoAVista.minimo && meuFormaPagamentoTipo <= 2 ? _itensParaDescontos - (_itensParaDescontos * _percentualDescontoAVista) : 0.00)
        );

        if (meuFormaPagamentoTipo <= 2) {
            setValorDescontosPagamentos(_vtDescontosPag);
            setQuantidadeDescontosPagamentos((descontoPagamentoAVista == null && Object.keys(descontoPagamentoAVista).length === 0 ? 0 :
                (_itensParaDescontos >= descontoPagamentoAVista.minimo && meuFormaPagamentoTipo <= 2 ? _produtosPossibildadeDescontos.length : 0)));
        }
        else {
            setValorDescontosPagamentos(0.00);
            setQuantidadeDescontosPagamentos(0);
        }

        // TOTAL DEVOLUÇÕES PAGAMENTOS
        let _fDevols = saton.filter((tipo) => tipo.especie == 2 && tipo.processo == null).filter(function (item) {
            return row.includes(item.ids_saton.toString() + "-" + item.ids_saton_loja.toString());
        });

        _vtDevoluvoesPag = _fDevols.map((s) => Number(s.total)).reduce((antes, atual) => antes + atual, 0);
        setValorTotalDevolucoesPagamentos(
            _vtDevoluvoesPag
        )
        setQuantidadeTotalDevolucoesPagamentos(_fDevols.length);

        // TOTAL CRÉDITOS PAGAMENTOS
        let _fCreds = saton.filter((tipo) => tipo.especie == 3 && tipo.processo == null).filter(function (item) {
            return row.includes(item.ids_saton.toString() + "-" + item.ids_saton_loja.toString());
        });
        _vtCreditosPag = _fCreds.map((s) => Number(s.total)).reduce((antes, atual) => antes + atual, 0);
        setValorTotalCreditosPagamentos(
            _vtCreditosPag
        )
        setQuantidadeTotalCreditosPagamentos(_fCreds.length);

        // SOMAR VALOR TOTAL PAGAMENTOS
        setTotalGeralPagamentos(_vtVendasPag - _vtDevoluvoesPag - _vtCreditosPag - _vtDescontosPag);

        // setFiltroAtivo(false);
    }

    const checarCalculoPagamentos = () => {
        let _vtVendasPag = 0.00;
        let _vtDevoluvoesPag = 0.00;
        let _vtCreditosPag = 0.00;
        let _vtDescontosPag = 0.00;

        //console.log("satonOriginal", satonOriginal);
        // setSaton(satonOriginal);        

        // TOTAL VENDAS PAGAMENTOS
        let _fVendas = saton.filter((t) => t.especie == 1 && t.processo == null).filter(function (item) {
            return selectionModel.includes(item.ids_saton.toString() + "-" + item.ids_saton_loja.toString());
        });
        _vtVendasPag = _fVendas.map((s) => Number(s.total)).reduce((antes, atual) => antes + atual, 0);

        setValorTotalVendasPagamentos(
            _vtVendasPag
        );
        setQuantidadeTotalVendasPagamentos(_fVendas.length);

        // TOTAL DESCONTOS PAGAMENTOS
        var startDate = new Date();
        startDate.setDate(startDate.getDate() - 7);  // 7 DIAS

        var _produtosPossibildadeDescontos = _fVendas.filter(a => {
            var date = new Date(a.data);
            return (date >= startDate);
        });

        setListaItensFaturadosDescontosPagamentos(_produtosPossibildadeDescontos);
        // setValorDescontosPagamentos(_produtosPossibildadeDescontos);

        let _percentualDescontoAVista = (descontoPagamentoAVista == null && Object.keys(descontoPagamentoAVista).length === 0 ? 0.00 : 1 + (descontoPagamentoAVista.juros / 100));
        let _itensParaDescontos = _produtosPossibildadeDescontos.map((s) => Number(s.total)).reduce((antes, atual) => antes + atual, 0);

        _vtDescontosPag = (descontoPagamentoAVista == null && Object.keys(descontoPagamentoAVista).length === 0 ? 0.00 :
            (_itensParaDescontos >= descontoPagamentoAVista.minimo && meuFormaPagamentoTipo <= 2 ? _itensParaDescontos - (_itensParaDescontos * _percentualDescontoAVista) : 0.00)
        );

        if (meuFormaPagamentoTipo <= 2) {
            setValorDescontosPagamentos(_vtDescontosPag);
            setQuantidadeDescontosPagamentos((descontoPagamentoAVista == null && Object.keys(descontoPagamentoAVista).length === 0 ? 0 :
                (_itensParaDescontos >= descontoPagamentoAVista.minimo && meuFormaPagamentoTipo <= 2 ? _produtosPossibildadeDescontos.length : 0)));
        }
        else {
            setValorDescontosPagamentos(0.00);
            setQuantidadeDescontosPagamentos(0);
        }

        // TOTAL DEVOLUÇÕES PAGAMENTOS
        let _fDevols = saton.filter((tipo) => tipo.especie == 2 && tipo.processo == null).filter(function (item) {
            return selectionModel.includes(item.ids_saton.toString() + "-" + item.ids_saton_loja.toString());
        });
        _vtDevoluvoesPag = _fDevols.map((s) => Number(s.total)).reduce((antes, atual) => antes + atual, 0);
        setValorTotalDevolucoesPagamentos(
            _vtDevoluvoesPag
        )
        setQuantidadeTotalDevolucoesPagamentos(_fDevols.length);

        // TOTAL CRÉDITOS PAGAMENTOS
        let _fCreds = saton.filter((tipo) => tipo.especie == 3 && tipo.processo == null).filter(function (item) {
            return selectionModel.includes(item.ids_saton.toString() + "-" + item.ids_saton_loja.toString());
        });
        _vtCreditosPag = _fCreds.map((s) => Number(s.total)).reduce((antes, atual) => antes + atual, 0);
        setValorTotalCreditosPagamentos(
            _vtCreditosPag
        )
        setQuantidadeTotalCreditosPagamentos(_fCreds.length);

        // SOMAR VALOR TOTAL PAGAMENTOS
        setTotalGeralPagamentos(_vtVendasPag - _vtDevoluvoesPag - _vtCreditosPag - _vtDescontosPag);
        // setFiltroAtivo(false);
    }

    const columns = [
        {
            field: 'quantidade',
            headerName: 'Quant.',
            width: 50,
            editable: false,
            align: 'right',
            disableExport: true,
            valueGetter: (params) =>
                `${(params.row.quantidade == 0 ? "" : params.row.quantidade || '')}`,
        },
        {
            field: 'codigo',
            headerName: 'Código',
            width: 75,
            editable: false,
            align: 'right',
            disableExport: true,
            valueGetter: (params) =>
                `${(params.row.codigo == 0 ? "" : params.row.codigo || '')}`,
        },
        {
            field: 'descricao',
            headerName: 'Descrição',
            width: 300, // 350
            editable: false,
        },
        {
            field: 'id_venda + "-" + id_venda_loja',
            headerName: 'ID Venda',
            width: 150,
            editable: false,
            valueGetter: (params) =>
                `${params.row.id_venda + "-" + params.row.id_venda_loja || ''}`,
        },
        {
            field: 'especie',
            headerName: 'Tipo',
            width: 150,
            editable: false,
            valueGetter: (params) =>
                `${identificaTipoOperacaoContasFaturadas(params.row.especie) || ''}`,
        },
        {
            field: 'data',
            headerName: 'Data e Hora',
            width: 150,
            editable: false,
            renderCell: (params) => (
                formatarDataHora(params.value, 6)
            ),
        },
        {
            field: 'total',
            headerName: 'Total',
            width: 150,
            editable: false,
            type: "number",
            align: 'right',
            renderCell: (params) => (
                params.value.toFixed(2)
            ),
        },
        {
            field: 'processo',
            headerName: 'Quitada',
            align: 'center',
            width: 65,
            renderCell: (params) => (
                (params.row.especie == 9 ? null : params.row.processo == null || params.row.processo <= 0 ? <CloseIcon color="error" /> : <CheckIcon color="success" />)
            ),
        },
        {
            field: 'processo + "-" + processo_loja',
            headerName: 'Processo',
            align: 'left',
            width: 85,
            valueGetter: (params) =>
                `${params.row.processo == null || params.row.processo <= 0 ? "" : params.row.processo + "-" + params.row.processo_loja || ''}`,
        }
    ];

    const customCheckbox = (params) => {
        if (params.row.especie === 9) {
            return null; // Remove checkbox for rows with tipo = 9
        }
        return <Checkbox checked={params.isSelected} />;
    };

    const columnsWithCheckbox = [
        {
            field: 'checkbox',
            headerName: '',
            width: 50,
            renderCell: customCheckbox,
            sortable: false,
            disableColumnMenu: true,
        },
        ...columns,
    ];

    const useStylesTypography = makeStyles({
        custom: {
            color: "#00EE00",
            fontWeight: "bold",
            paddingTop: "10px",
            marginTop: "10px",
        }
    });

    const classesTypography = useStylesTypography();

    const localizedTextsMap = {
        columnMenuUnsort: "Não Ordenado",
        columnMenuSortAsc: "Ordem Crescente",
        columnMenuSortDesc: "Ordem Cecrescente",
        columnMenuFilter: "Filtro",
        columnMenuHideColumn: "Ocultar",
        columnMenuShowColumns: "Mostrar Colunas",
        columnHeaderSortIconLabel: 'Ordenar',
        noRowsLabel: 'Nenhuma Linha',
        footerTotalRows: 'Total de Linhas:',
        filterPanelOperators: 'Operador',
        filterPanelColumns: 'Coluna',
        filterPanelInputLabel: 'Valor',
        filterOperatorContains: 'contém',
        filterOperatorEquals: 'igual',
        filterOperatorStartsWith: 'começa com',
        filterOperatorEndsWith: 'termina com',
        filterOperatorIs: 'é',
        filterOperatorNot: 'não é',
        filterOperatorAfter: 'depois de',
        filterOperatorOnOrAfter: 'igual ou depois',
        filterOperatorBefore: 'antes de',
        filterOperatorOnOrBefore: 'igual ou antes',
        filterOperatorIsEmpty: 'é vazio',
        filterOperatorIsNotEmpty: 'não é vazio',
        filterOperatorIsAnyOf: 'é qualquer um',
        filterPanelInputPlaceholder: 'Pesquisar',
        toolbarFiltersTooltipActive: (count) =>
            count !== 1 ? `${count} filtro ativo` : `${count} filtros ativos`,
        footerTotalVisibleRows: (visibleCount, totalCount) =>
            `${visibleCount.toLocaleString()} de ${totalCount.toLocaleString()}`,

        footerRowSelected: (count) =>
            count !== 1
                ? `${count.toLocaleString()} Linhas Selecionadas`
                : `${count.toLocaleString()} Linha Selecionada`,

    };

    const handleCloseNao = () => {
        setOpenDialogoDevolucoes(false);
    };

    const handleCloseSim = () => {
        SalvarPreDevolucao();
    };

    const desativarFiltro = () => {
        if (filtroAtivo) {
            setFiltroAtivo(false);
        }
        // setFiltroAtivo(true);
        // setFiltroAtivo(false);    
    }

    function TipoPagamento(value) {
        if (value <= 2) {
            // setPagamentoNumeroMaximoParcelas({ prestacao: 1 });
            // setCartaoTipoCartao(0);
            // TelaTipoDeCartaoCreditoOuDebito(0);
            // setDataGridPositionY(267);
            // var startDate = new Date();
            // startDate.setDate(startDate.getDate() - 7);  // 7 DIAS

            // let _produtosPossibildadeDescontos = listaItensFaturadosDescontosPagamentos;
            // let _percentualDescontoAVista = (descontoPagamentoAVista == null && Object.keys(descontoPagamentoAVista).length === 0 ? 0.00 : 1 + (descontoPagamentoAVista.juros / 100));
            // let _itensParaDescontos = _produtosPossibildadeDescontos.map((s) => Number(s.total)).reduce((antes, atual) => antes + atual, 0);
            // let _vtDescontosPag = (descontoPagamentoAVista == null && Object.keys(descontoPagamentoAVista).length === 0 ? 0.00 :
            //     (_itensParaDescontos >= descontoPagamentoAVista.minimo && value <= 2 ? _itensParaDescontos - (_itensParaDescontos * _percentualDescontoAVista) : 0.00)
            // );
            // setPagamentoNumeroParcelas(1);
            // setValorDescontosPagamentos(_vtDescontosPag);
            // setQuantidadeDescontosPagamentos((descontoPagamentoAVista == null && Object.keys(descontoPagamentoAVista).length === 0 ? 0 :
            //     (_itensParaDescontos >= descontoPagamentoAVista.minimo && value <= 2 ? _produtosPossibildadeDescontos.length : 0)));
            // setTotalGeralPagamentos(valorTotalVendasPagamentos - valorTotalDevolucoesPagamentos - valorTotalCreditosPagamentos - _vtDescontosPag);
            console.log("PGT A");

        } else {

            setDataGridPositionY(618);
            api.get('Prazos/' + totalGeralPagamentos).then((response) => {
                setPagamentoNumeroMaximoParcelas(response?.data);
                setCartaoTipoCartao(0);
                TelaTipoDeCartaoCreditoOuDebito(0);
                setValorDescontosPagamentos(0.00);
                setQuantidadeDescontosPagamentos(0);
                setTotalGeralPagamentos(valorTotalVendasPagamentos - valorTotalDevolucoesPagamentos - valorTotalCreditosPagamentos);
                setPagamentoNumeroParcelas(-1);
                setPagamentoValorParcelas(DividirParcelamentosCartoes(response?.data));

                console.log("PGT B");

            }).catch((e) => {
                console.log(e);

                console.log("PGT C");
            })
        }
        if (meuFormaPagamentoTipo != value) {
            setMeuFormaPagamentoTipo(Number(value)); // Tipo de Pagamento 1 - PIX / 2 - BOLETO / 3 - CARTÃO CRÉDITO ou DÉBITO
            console.log("PGT D");
        }
    }

    function TelaTipoDeCartaoCreditoOuDebito(modeloCartao) {
        // 0 - Cartão de Crédito / 1 -Cartão de Débito
        // 0 - Cartão de Crédito
        if (modeloCartao == 0) {
            setCartaoSolicitarCPF_CNPJ(true);
            setCartaoTipoCartao(0);
            setPagamentoNumeroParcelas(0);
            setPagamentoOpcaoSelecionada("");
            setPagamentoNumeroParcelasError("");
        }
        // 1 -Cartão de Débito
        else if (modeloCartao == 1) {
            setCartaoSolicitarCPF_CNPJ(false);
            setCartaoTipoCartao(1);
            setPagamentoNumeroParcelas(1);
            setPagamentoOpcaoSelecionada("");
            setPagamentoNumeroParcelasError("");
        }
    }

    const LimparFiltrarDados = () => {
        //let _selectionModelMarcados = selectionModel;
        setSaton(satonOriginal);
        //setSelectionModel(_selectionModelMarcados);
        setFiltroAtivo(false);
        setFiltroIDVenda_Loja("");        
        //setSaton(satonOriginal);
        // setSelectionModel(selectedRows);    
        checarCalculoPagamentos();
    };

    const FiltrarDados = () => {
        if (filtroIDVenda_Loja) {
            let _valorDigitado = filtroIDVenda_Loja;
            if (filtroIDVenda_Loja.replaceAll(" ", "").split('-').length < 2) {
                let _valorSemTraco = filtroIDVenda_Loja.replaceAll(" ", "");
                let _posicaoTraco = _valorSemTraco.length - 1;
                _valorDigitado = _valorSemTraco.substring(0, _posicaoTraco) + "-" + _valorSemTraco.substring(_posicaoTraco, _posicaoTraco + 1);
                // toastMensagemError("DIGITE ID VENDA-LOJA JUNTOS!");
                // return;
            }
            if (_valorDigitado.split('-').length != 2) {
                toastMensagemError("VERIFIQUE O ID VENDA-LOJA DIGITADO!");
                return;
            }            
            let _idVenda = _valorDigitado.split('-')[0];
            let _idVendaLoja = _valorDigitado.split('-')[1];
            setFiltroIDVenda_Loja(_idVenda + "-" + _idVendaLoja);
            //let _registros = satonOriginal.filter((s) => s.id_venda == Number(_idVenda) && s.id_venda_loja == Number(_idVendaLoja));
            //let _registrosMarcadosAnteriormente = satonOriginal.filter((s) => s..id_venda == Number(_idVenda) && s.id_venda_loja == Number(_idVendaLoja));
            // console.log("AQUI ", selectionModel);
            // console.log("AQUI 222", saton);
            // let _selectionModelMarcados = selectionModel;
            setSaton(saton.filter((s) => s.id_venda == Number(_idVenda) && s.id_venda_loja == Number(_idVendaLoja)));
            // setSelectionModel(_selectionModelMarcados)
            //setSaton(satonOriginal.filter((s) => s.id_venda == Number(_idVenda) && s.id_venda_loja == Number(_idVendaLoja)));  // VOLTAR
            setFiltroAtivo(true);
            return;
        }
        ///////
        let _dataIni = new Date(filtroDataInicial);
        let _dataFin = new Date(filtroDataFinal);
        if (isNaN(_dataIni.getTime())) {
            toastMensagemError("DATA INICIAL INVÁLIDA!");
            return;
        }
        if (isNaN(_dataFin.getTime())) {
            toastMensagemError("DATA FINAL INVÁLIDA!");
            return;
        }
        if (_dataIni.getTime() > _dataFin.getTime()) {
            toastMensagemError("DATA FINAL MAIOR QUE A DATA INICIAL!");
            return;
        }
        _dataFin = convertDateTimeFinalDia(_dataFin);
        if (filtroCodigo != null && filtroCodigo != "" && filtroCodigo[0] != null) {
            // Código
            // let _selectionModelMarcados = selectionModel;
            setSaton(saton.filter((s) => s.codigo == Number(filtroCodigo[0]) && new Date(s.data).getTime() >= _dataIni && new Date(s.data).getTime() <= _dataFin));
            // setSelectionModel(_selectionModelMarcados)
            setFiltroAtivo(true);
        }
        else {
            // Data Inicial + Data Final
            // let _selectionModelMarcados = selectionModel;
            setSaton(saton.filter((s) => new Date(s.data).getTime() >= _dataIni && new Date(s.data).getTime() <= _dataFin));
            // setSelectionModel(_selectionModelMarcados)
            setFiltroAtivo(true);
        }
        return;
    };

    function RecalcularTotais() {
        setTotalGeral(valorTotalVendas - valorTotalDevolucoes - valorTotalCreditos - valorDescontosPagamentos + valorTotalDuplicatas + valorTotalChequesDevolvidos);
    }
    // console.log("CARACA ", saton);

    function PegarDescontoAVista() {
        api.get('Prazos/DescontoAVistaPrazoPagamento').then((response) => {
            setDescontoPagamentoAVista(response?.data);
        }).catch((e) => {
            if (e == "Error: Network Error") {
                toastErroApiNaoResponde();
                // setFreteError("Ops, Nosso Servidor Não Respondeu...");
                return null;
            }
            // setFreteError(e);
            return null;
        });
    }

    function EfetuarSolicitacaoParaDevolucoes(e) {
        if (selectionModelDevolucoes == null || selectionModelDevolucoes.length === 0) {
            toastMensagemError("SELECIONE PELO MENOS UM PRODUTO PARA DEVOLVER!");
            return;
        }
        SetDialogoMensagemDevolucoes(selectionModelDevolucoes.length + (selectionModelDevolucoes.length > 1 ? " Produtos Selecionados?" : " Produto Selecionado?"));
        setOpenDialogoDevolucoes(true);
    }


    function BuscarComprasFaturadas(usuario_logado) {
        let _userId = usuario_logado.split('_')[0];
        let _userIdloja = usuario_logado.split('_')[1];

        PegarDescontoAVista();

        api.get(`Saton/Saton/${_userId}/${_userIdloja}?aberto=${(switchAbertas ? 1 : 0)}`)
            .then((data) => {
                let _soma = 0.00;
                let _idsVendaRegistro = 0;
                let _idsVendaRegistroLoja = 0;
                let novaArrayComTotais = [];
                if (data.data.length > 0) {
                    let _registroSomando = data.data[0];
                    _idsVendaRegistro = _registroSomando.id_venda;
                    _idsVendaRegistroLoja = _registroSomando.id_venda_loja;

                    //data.data.forEach((element, index) => {
                    // if (element.id_venda != _idsVendaRegistro || (index + 1) == data.data.length) {
                    //     let newLinha = {
                    //         codigo: 0,
                    //         data: _registroSomando.data,
                    //         data_devolucao: null,
                    //         descricao: "DIA " + formatarDataHora(_registroSomando.data.toString(), 4) + " ...................... TOTAL R$",
                    //         especie: 9,
                    //         id_cliente: _registroSomando.id_cliente,
                    //         id_cliente_loja: _registroSomando.id_cliente_loja,
                    //         id_venda: _registroSomando.id_venda,
                    //         id_venda_loja: _registroSomando.id_venda_loja,
                    //         ids_saton: _registroSomando.ids_saton * -1,
                    //         ids_saton_loja: _registroSomando.ids_saton_loja,
                    //         nfe_coo: null,
                    //         nfe_loja: null,
                    //         nfe_mod: null,
                    //         nfe_serie: null,
                    //         observacao: null,
                    //         placa: null,
                    //         processo: null,
                    //         processo_devolucao: null,
                    //         processo_devolucao_loja: null,
                    //         processo_loja: _registroSomando.processo_loja,
                    //         quantidade: 0,
                    //         total: _soma,
                    //         unitario: _soma,
                    //         user_devolucao: null,
                    //         vencimento: null,
                    //         vendedor: 0
                    //     };
                    //     _soma = (element.especie == 2 ? element.total * -1 : element.total);
                    //     _idsVendaRegistro = element.id_venda;
                    //     _idsVendaRegistroLoja = element.id_venda_loja;
                    //     novaArrayComTotais.push(newLinha)
                    //     _registroSomando = element;
                    // }
                    // else {
                    //     _soma += (element.especie == 2 ? element.total * -1 : element.total);
                    // }
                    //});

                    // INÍCIO DO ADICIONA A SOMA NO ÚLTIMO REGISTRO DA LISTA (CÓPIA DA)

                    // let newLinha = {
                    //     codigo: 0,
                    //     data: _registroSomando.data,
                    //     data_devolucao: null,
                    //     descricao: "DIA " + formatarDataHora(_registroSomando.data.toString(), 4) + " ...................... TOTAL R$",
                    //     especie: 9,
                    //     id_cliente: _registroSomando.id_cliente,
                    //     id_cliente_loja: _registroSomando.id_cliente_loja,
                    //     id_venda: _registroSomando.id_venda,
                    //     id_venda_loja: _registroSomando.id_venda_loja,
                    //     ids_saton: _registroSomando.ids_saton * -1,
                    //     ids_saton_loja: _registroSomando.ids_saton_loja,
                    //     nfe_coo: null,
                    //     nfe_loja: null,
                    //     nfe_mod: null,
                    //     nfe_serie: null,
                    //     observacao: null,
                    //     placa: null,
                    //     processo: null,
                    //     processo_devolucao: null,
                    //     processo_devolucao_loja: null,
                    //     processo_loja: _registroSomando.processo_loja,
                    //     quantidade: 0,
                    //     total: _soma,
                    //     unitario: _soma,
                    //     user_devolucao: null,
                    //     vencimento: null,
                    //     vendedor: 0
                    // };
                    // novaArrayComTotais.push(newLinha)

                    // FINAL DO ADICONA A SOMA NO ÚLTIMO REGISTRO DA LISTA 
                }

                const satonOrdenado = [...data.data.sort((a, b) => {
                    // Only sort on age if not identical
                    if (a.id_venda < b.id_venda && a.id_venda_loja == b.id_venda_loja) return -1;
                    if (a.id_venda > b.id_venda && a.id_venda_loja == b.id_venda_loja) return 1;
                    // Sort on especie
                    if (a.especie < b.especie) return -1;
                    if (a.especie > b.especie) return 1;
                    // Sort on name
                    if (a.codigo > 0 && a.codigo < b.codigo) return -1;
                    if (a.codigo > 0 && a.codigo > b.codigo) return 1;
                    // Both idential, return 0
                    return 0;
                })];

                const satonFinal = data.data.concat(novaArrayComTotais);

                const satonFinalSorted = [...satonFinal.sort((a, b) => {
                    // Only sort on age if not identical
                    if (a.id_venda < b.id_venda && a.id_venda_loja == b.id_venda_loja) return -1;
                    if (a.id_venda > b.id_venda && a.id_venda_loja == b.id_venda_loja) return 1;
                    // Sort on especie
                    if (a.especie < b.especie) return -1;
                    if (a.especie > b.especie) return 1;
                    // Sort on name
                    if (a.codigo < b.codigo) return -1;
                    if (a.codigo > b.codigo) return 1;
                    // Both idential, return 0
                    return 0;
                })];


                setSaton(satonFinalSorted);
                setSatonOriginal(satonFinalSorted);

                // setSaton(data.data);
                // setSatonOriginal(satonOrdenado);
                setQuantidadeTotalVendas(satonOrdenado.filter((s) => s.especie == 1 && s.processo == null).length); // VENDAS
                setValorTotalVendas(satonOrdenado.filter((s) => s.especie == 1 && s.processo == null).map((s) => Number(s.total)).reduce((antes, atual) => antes + atual, 0)); // VENDAS
                setQuantidadeTotalDevolucoes(satonOrdenado.filter((s) => s.especie == 2 && s.processo == null).length); // DEVOLUÇÃO
                setValorTotalDevolucoes(satonOrdenado.filter((s) => s.especie == 2 && s.processo == null).map((s) => Number(s.total)).reduce((antes, atual) => antes + atual, 0)); // DEVOLUÇÃO
                setQuantidadeTotalCreditos(satonOrdenado.filter((s) => s.especie == 3 && s.processo == null).length); // CRÉDITOS
                setValorTotalCreditos(satonOrdenado.filter((s) => s.especie == 3 && s.processo == null).map((s) => Number(s.total)).reduce((antes, atual) => antes + atual, 0)); // CRÉDITOS

                setFiltroDataInicial(
                    satonOrdenado.map(m => m.data).reduce((previous, current) => {
                        return current.data < previous.data ? current : previous;
                    }));
                setFiltroDataFinal(
                    satonOrdenado.map(m => m.data).reduce((previous, current) => {
                        return current.data > previous.data ? previous : current;
                    }));

            })
            .catch((error) => {
                /// console.log(error.message)
                if (error == "Error: Network Error") {
                    toastErroApiNaoResponde();
                    return null;
                }
            });
    }

    function BuscarChequesDevolvidos(usuario_logado) {
        let _userId = usuario_logado.split('_')[0];
        let _userIdloja = usuario_logado.split('_')[1];
        api.get(`Cheques/QuantidadeChequesDevovidos/${_userId}/${_userIdloja}?aberto=${(switchAbertas ? 1 : 0)}`)
            .then((response) => {
                return response;
            })
            .then((data) => {
                setQuantidadeTotalChequesDevolvidos(data.data.quantidadeChequesDevolvidos);
                setValorTotalChequesDevolvidos(data.data.valorTotalChequesDevolvidos);
            })
            .catch((error) => {
                /// console.log(error.message)
                if (error == "Error: Network Error") {
                    toastErroApiNaoResponde();
                    return null;
                }
            });
    }

    function BuscarDuplicatas(usuario_logado) {
        let _userId = usuario_logado.split('_')[0];
        let _userIdloja = usuario_logado.split('_')[1];
        api.get(`Duplicata/QuantidadeDuplicata/${_userId}/${_userIdloja}?aberto=${(switchAbertas ? 1 : 0)}`)
            .then((data) => {
                setQuantidadeTotalDuplicatas(data.data.quantidadeDuplicatas);
                setValorTotalDuplicatas(data.data.valorTotalDuplicatas);
            })
            .catch((error) => {
                /// console.log(error.message)
                if (error == "Error: Network Error") {
                    toastErroApiNaoResponde();
                    return null;
                }
            });
    }


    const toggleAbertaChecked = () => {
        setSwitchAbertas((prev) => !prev);
    };


    const calculateSum = (data, groupByField) => {
        const groupedData = data.reduce((acc, row) => {
            const group = row[groupByField];
            if (!acc[group]) {
                acc[group] = 0;
            }
            acc[group] += row.total;
            return acc;
        }, {});
        return groupedData;
    };

    const groupByField = 'ids_venda';
    const sumData = calculateSum(saton, groupByField);

    // const enhancedRows = () =>{
    //     console.log("CARACO ", saton);
    //     let _soma = 0.00;
    //     let _idsVendaRegistro = 0; 
    //     if (saton.length > 0){
    //         saton.forEach((element) => {
    //             console.log("CARACA ", element);
    //             // if (_idsVendaRegistro != element.id_venda){
    //             //     _soma += element.total;
    //             // }
    //         });
    //     }



    //     // saton.concat(        
    //     //     Object.keys(saton).map((group, index) => ({
    //     //         id: `sum-${group}`,
    //     //         quantidade: 0,
    //     //         codigo: 0,
    //     //         descricao: "TOTAL R$",
    //     //         total: calculateSum(saton,"ids_venda"), //[group],
    //     //         ids_venda: index, 
    //     //         ids_venda_loja: 1,
    //     //         isSummary: true,
    //     //     }))
    //     //     //console.log("JOAO A" )
    //     // );   

    // } 

    // console.log("BAVAVA ", enhancedRows);

    const codigoDigitado = (e) => {
        setFiltroCodigo(aceitaApenasNumeros(e.target.value))
    };

    const idVenda_lojaDigitado = (e) => {
        LimparFiltrarDados();
        let _dig = e.target.value.replace(/[a-zA-Z]/g, "").replace("--", "-").replace("[a-zA-Z]", "").replace(/([0-9]+?)([0-9]\d{1-3})(?=.*?\.|$)/mg, "$1-$2");
        setFiltroIDVenda_Loja(_dig);
    };

    const dataInicialDigitada = (e) => {
        setFiltroDataInicial(e);
        setFiltroDataFinal(e);
        setFiltroAtivo(false);
    };




    const cStyledDataGrid = styled(DataGrid)(({ theme }) => ({
        '& .MuiDataGrid-row.branco': {
            backgroundColor: 'white',
        },
        '& .MuiDataGrid-row.amarelo': {
            backgroundColor: "rgba(255, 255, 236, 0.75)", // AMARELO
        },
        '& .MuiDataGrid-checkboxInput.branco': {
            color: 'white',
        },
        '& .MuiDataGrid-checkboxInput.amarelo': {
            color: "rgba(255, 255, 236, 0.75)",  // AMARELO
        },
    }));

    const cgetRowClassName = (params) => {
        // Obtenha o índice da linha e alterne as cores
        if (params.id != null && (params.row.id_venda + "-" + params.row.id_venda_loja) != _notaAgrupada) {  //  params.field == "id_venda + \"-\" + id_venda_loja"){
            // if (params.field == "quantidade" && _notaAgrupada != params.value){
            if (_corNotaAgrupada == "branco") {
                _corNotaAgrupada = "amarelo";
            }
            else {
                _corNotaAgrupada = "branco";
            }
            _notaAgrupada = (params.row.id_venda + "-" + params.row.id_venda_loja);
            // }
        }
        return _corNotaAgrupada;
    };

    const cgetCellClassName = (params) => {
        return params.row.isSummary ? 'summary-row' : '';
    };


    const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
        '& .MuiDataGrid-row.branco': {
          backgroundColor: 'white',
        },
        '& .MuiDataGrid-row.amarelo': {
          backgroundColor: 'rgba(255, 255, 236, 0.75)', // Amarelo
        },
      }));

      const getRowClassName = (params) => {
        const { processo_id, processo_loja } = params.row;
        return (processo_id + processo_loja) % 2 === 0 ? 'amarelo' : 'branco';
      };

      const handleSelectionChange = useCallback((newSelection) => {
        setSelectionModel(newSelection);
      }, []);
    


    const dataFinalDigitada = (e) => {
        setFiltroDataFinal(e);
        // let _dF = document.getElementById("textFiltroDataFinal");
        // if (aceitaApenasDatas(_dF.value)) {
        //   setFiltroDataFinal(_dF.value);
        // }
        // else {
        //   setFiltroDataFinal(null);
        // }
        setFiltroAtivo(false);
    };

    const classes = useStyles();

    return (
        <div>
            <BrowserView>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-around"
                    alignItems="flex-start"
                    width={"99.2%"}
                    marginTop={"10px"}
                    // height={"266px"}          
                    height={`${dataGridPositionY}px`}
                >
                    {/* SOMATÓRIO TOPO ESQUERDO */}
                    <Grid item xs={4.3} height={"220px"} sx={{ fontFamily: `"Roboto", "Helvetica", "Arial", "sans-serif"`, fontSize: '16px', fontWeight: 'bold' }}>

                        <Grid container sx={{ alignItems: "center", marginLeft: '10px' }}>

                            <Grid item xs={12} sx={{ fontFamily: `"Roboto", "Helvetica", "Arial", "sans-serif"`, fontSize: '16px', fontWeight: 'bold', marginTop: '1px' }}>
                                <Box sx={{ border: 1, borderColor: '#ddd', width: '98.4%', borderRadius: '6px' }}>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="flex-start"
                                        alignItems="flex-start"
                                    >
                                        <Grid item xs={12} sx={{ alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#EAFAF1", borderBottom: "solid 1px #ddd" }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'10px'} marginLeft={"10px"}>Cliente: <b>{usuarioLogado.replace("_", "-")}</b> Nome: <b>{nomeFullRazaoSocialLogado}</b></Typography>
                                        </Grid>

                                        <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#f5f5dc' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'}>Quantidades</Typography>
                                        </Grid>
                                        <Grid item xs={5.67} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#f5f5dc' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={'10px'} marginTop={'12px'}>Tipo Operação</Typography>
                                        </Grid>
                                        <Grid item xs={4.05} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#f5f5dc' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={'10px'} marginTop={'12px'}>Valor Total R$</Typography>
                                        </Grid>


                                        <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'}><b>{quantidadeTotalVendas}</b></Typography>
                                        </Grid>
                                        <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginLeft={'6px'} marginTop={'12px'}><b>COMPRAS</b></Typography>
                                        </Grid>
                                        <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginRight={'10px'} marginTop={'12px'}><b>{valorTotalVendas.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                                        </Grid>

                                        <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'}><b>{quantidadeTotalDevolucoes}</b></Typography>
                                        </Grid>
                                        <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginLeft={'6px'} marginTop={'12px'}><b>DEVOLUÇÕES</b></Typography>
                                        </Grid>
                                        <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginRight={'10px'} marginTop={'12px'}><b>{valorTotalDevolucoes.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                                        </Grid>

                                        <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'}><b>{quantidadeTotalCreditos}</b></Typography>
                                        </Grid>
                                        <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginLeft={'6px'} marginTop={'12px'}><b>CRÉDITOS</b></Typography>
                                        </Grid>
                                        <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginRight={'10px'} marginTop={'12px'}><b>{valorTotalCreditos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                                        </Grid>


                                        <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'}><b>{quantidadeTotalDuplicatas}</b></Typography>
                                        </Grid>
                                        <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginLeft={'6px'} marginTop={'12px'}><b>DUPLICATAS</b>
                                                <IconButton onClick={() => FiltrarDados()} color="primary" aria-label="Ver Duplicatas" style={{ height: '5px', maxHeight: '5px', marginLeft: '5px' }}>
                                                    <VisibilityIcon style={{ color: (filtroAtivo ? "red" : "green") }} />
                                                </IconButton>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginRight={'10px'} marginTop={'12px'}><b>{valorTotalDuplicatas.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                                        </Grid>

                                        <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'}><b>{quantidadeTotalChequesDevolvidos}</b></Typography>
                                        </Grid>
                                        <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginLeft={'6px'} marginTop={'12px'}><b>CHEQUES DEVOLVIDOS</b>
                                                <IconButton onClick={() => ShowModalMeusCheques()} color="primary" aria-label="Ver Duplicatas" style={{ height: '5px', maxHeight: '5px', marginLeft: '5px' }}>
                                                    <VisibilityIcon style={{ color: (filtroAtivo ? "red" : "green") }} />
                                                </IconButton>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginRight={'10px'} marginTop={'12px'}><b>{valorTotalChequesDevolvidos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                                        </Grid>

                                        <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                            <img src={SetaDireita} alt="Seta" style={{ width: '23px', height: 'auto', marginTop: '1px' }} />
                                        </Grid>
                                        <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginLeft={'6px'} marginTop={'20px'}><b>TOTAL GERAL R$</b></Typography>
                                        </Grid>
                                        <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginRight={'10px'} marginTop={'12px'}><b>{totalGeral.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                                        </Grid>

                                    </Grid>
                                </Box>
                            </Grid>

                        </Grid>
                    </Grid>

                    {/* FILTROS TOPO CENTRO */}

                    <Grid item xs={3.5} height={"264px"} sx={{ fontFamily: `"Roboto", "Helvetica", "Arial", "sans-serif"`, fontSize: '16px', fontWeight: 'bold', border: 1, borderColor: '#ddd', borderRadius: '6px', marginLeft: "6px" }}
                    >
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                        >
                            <Grid item xs={12} sx={{ alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#EAFAF1", borderBottom: "solid 1px #ddd", borderTopLeftRadius: '6px' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'10px'} marginLeft={"10px"} > Usuário: <b>{nomeUsuarioLogado}</b></Typography>
                            </Grid>

                            <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#f5f5dc' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'}>Quantidades</Typography>
                            </Grid>
                            <Grid item xs={5.67} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#f5f5dc' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={'10px'} marginTop={'12px'}>Tipo Operação</Typography>
                            </Grid>
                            <Grid item xs={4.05} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#f5f5dc' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={'10px'} marginTop={'12px'}>Valor Total R$</Typography>
                            </Grid>

                            <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'}><b>{quantidadeTotalVendasPagamentos}</b></Typography>
                            </Grid>
                            <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginLeft={'20px'} marginTop={'12px'}><b>COMPRAS</b></Typography>
                            </Grid>
                            <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginRight={'10px'} marginTop={'12px'}><b>{valorTotalVendasPagamentos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                            </Grid>

                            <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'}><b>{quantidadeTotalDevolucoesPagamentos}</b></Typography>
                            </Grid>
                            <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginLeft={'20px'} marginTop={'12px'}><b>DEVOLUÇÕES</b></Typography>
                            </Grid>
                            <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginRight={'10px'} marginTop={'12px'}><b>{valorTotalDevolucoesPagamentos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                            </Grid>


                            <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'}><b>{quantidadeTotalCreditosPagamentos}</b></Typography>
                            </Grid>
                            <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginLeft={'20px'} marginTop={'12px'}><b>CRÉDITOS</b></Typography>
                            </Grid>
                            <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginRight={'10px'} marginTop={'12px'}><b>{valorTotalCreditosPagamentos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                            </Grid>

                            <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'}><b>{quantidadeDescontosPagamentos}</b></Typography>
                            </Grid>
                            <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginLeft={'20px'} marginTop={'12px'}><b>DESCONTOS</b></Typography>
                            </Grid>
                            <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginRight={'10px'} marginTop={'12px'}><b>{((meuFormaPagamentoTipo <= 2 ? valorDescontosPagamentos : 0.00)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                            </Grid>
                            <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0', borderBottom: "solid 1px #ddd" }}>
                                <img src={SetaDireita} alt="Seta" style={{ width: '21px', height: 'auto' }} />
                            </Grid>
                            <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#f5f5dc", backgroundColor: '#fffff0', borderBottom: "solid 1px #ddd" }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginLeft={'20px'} marginTop={'20px'}><b>TOTAL GERAL R$</b></Typography>
                            </Grid>
                            <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", backgroundColor: '#fffff0', borderBottom: "solid 1px #ddd" }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginRight={'10px'} marginTop={'12px'}><b>{totalGeralPagamentos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                            </Grid>

                        </Grid>
                    </Grid>


                    {/* FILTROS TOPO DIREITO */}
                    <Grid item xs={4.10} sx={{
                        fontFamily: `"Roboto", "Helvetica", "Arial", "sans-serif"`, fontSize: '16px', fontWeight: 'bold', height: '264px', marginLeft: '1px', borderBottomLeftRadius: '6px', borderBottomRightRadius: '6px'
                    }}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            sx={{ border: 1, borderColor: '#ddd', borderRadius: '6px', backgroundColor: '#FFFFF0' }}
                        >
                            <Grid item xs={12} sx={{ alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#EAFAF1" }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'10px'} marginLeft={"10px"} ><b>Filtros de Pesquisa</b></Typography>
                            </Grid>

                            <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                <Box component="form">
                                    <TextField
                                        type="tel"
                                        id="textFiltroCodigo"
                                        label="Código"
                                        variant="outlined"
                                        onChange={(e) => codigoDigitado(e)}
                                        value={filtroCodigo}
                                        size="small"
                                        sx={{ marginLeft: '6px', marginTop: '6px' }}
                                    />
                                </Box>
                            </Grid>

                            <Grid item xs={2.90} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                <Box component="form">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            className={classesDatePicker.root}
                                            mask="__/__/____"
                                            label="Data Inicial"
                                            inputFormat="DD/MM/YYYY"
                                            value={filtroDataInicial}
                                            onChange={(e) => dataInicialDigitada(e)}
                                            disableOpenPicker
                                            renderInput={(params) => <TextField {...params} size="small" sx={{ marginTop: "6.4px", marginLeft: "4px" }}
                                                inputProps={
                                                    {
                                                        ...params.inputProps,
                                                        placeholder: "dd/mm/aaaa"
                                                    }
                                                }
                                            />}

                                        />
                                    </LocalizationProvider>
                                </Box>
                            </Grid>

                            <Grid item xs={2.91} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                <Box component="form">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            className={classesDatePicker.root}
                                            mask="__/__/____"
                                            label="Data Final"
                                            inputFormat="DD/MM/YYYY"
                                            value={filtroDataFinal}
                                            onChange={(e) => dataFinalDigitada(e)}
                                            disableOpenPicker
                                            renderInput={(params) => <TextField {...params} size="small" sx={{ marginTop: "6.4px", marginLeft: "4px" }}
                                                inputProps={
                                                    {
                                                        ...params.inputProps,
                                                        placeholder: "dd/mm/aaaa"
                                                    }
                                                }
                                            />}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </Grid>

                            <Grid item xs={3.90} style={{ textAlign: "right", alignContent: "right", alignItems: "right", backgroundColor: '#fffff0' }}>
                                <Box component="form">
                                    <TextField
                                        type="tel"
                                        id="textFiltroIDVenda"
                                        label="ID Venda-Loja"
                                        variant="outlined"
                                        onChange={(e) => idVenda_lojaDigitado(e)}
                                        value={filtroIDVenda_Loja}
                                        size="small"
                                        sx={{ marginLeft: '6px', marginTop: '6px', marginRight: '6px' }}
                                    />
                                </Box>
                            </Grid>

                            <Grid item xs={12} justifyContent={"space-around"} style={{ backgroundColor: '#fffff0', borderBottom: "solid 1px #ddd" }}>
                                {/* <Stack direction="row" spacing={2}> */}

                                <FormControlLabel control={
                                    <Switch defaultChecked checked={switchAbertas} style={{ color: "green", marginRight: '10px' }} />
                                } label={(switchAbertas ? "Abertas" : "Fechadas")} onChange={toggleAbertaChecked} sx={{ minWidth: "150px" }} />

                                <IconButton onClick={() => FiltrarDados()} color="primary" aria-label="Adicionar Filtro">
                                    <FilterAltIcon style={{ color: (filtroAtivo ? "red" : "green") }} />
                                </IconButton>

                                <IconButton onClick={() => LimparFiltrarDados()} color="primary" aria-label="Remover Filtro">
                                    <FilterAltOffIcon style={{ color: "green" }} />
                                </IconButton>
                                <Button variant="contained" startIcon={<ArchiveIcon />} onClick={(e) => EfetuarSolicitacaoParaDevolucoes(e)} style={{ backgroundColor: '#357a38', maxWidth: '140px', maxHeight: '25px', marginTop: '10px', marginBottom: '10px', marginLeft: "35px" }}>
                                    Devoluções
                                </Button>
                                {/* </Stack> */}
                            </Grid>

                            <Grid item xs={12} style={{ textAlign: "left", alignContent: "left", alignItems: "left", backgroundColor: '#fffff0' }}>

                                {switchAbertas ?

                                    /* PAGAMENTO PEDIDO INÍCIO */
                                    <>

                                        <Typography variant="caption" fontFamily={'roboto'} fontSize={'10px'} marginLeft={"10px"}><b>Formas de Pagamentos</b></Typography>

                                        <Stack spacing={2} direction="row">
                                            <Stack direction="column">
                                                {/* <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                        Alguns Tipos de Pagamentos Podem Possuir Descontos*
                      </Typography>
                      <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} /> */}
                                                <Stack direction="row" maxHeight={50}>

                                                    <Grid container spacing={2}>
                                                        <Grid item xs={4}>
                                                            <img src={(meuFormaPagamentoTipo === 1 ? pixIcon : pixIconDisabled)} onClick={(e) => TipoPagamento(1)} style={{ height: '50px', maxHeight: '50px', cursor: 'pointer', marginLeft: '16px' }} />
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <img src={(meuFormaPagamentoTipo === 2 ? boletoIcon : boletoIconDisabled)} onClick={(e) => TipoPagamento(2)} style={{ height: '50px', maxHeight: '50px', marginLeft: '35px', cursor: 'pointer' }} />
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <img src={(meuFormaPagamentoTipo === 3 ? cartoes_selecaoIcon : cartoes_selecaoIconDisabled)} onClick={(e) => TipoPagamento(3)} sx={{ height: '45px', maxHeight: '45px' }} style={{ cursor: 'pointer', marginLeft: '35px', height: '45px' }} />
                                                        </Grid>
                                                    </Grid>
                                                </Stack>

                                                <Typography sx={{ fontSize: '15px', marginTop: '5px', marginLeft: '10px' }} color="text.primary" textAlign={"left"}>
                                                    {(pagamentoNumeroMaximoParcelas?.prestacao != null && pagamentoNumeroMaximoParcelas?.prestacao > 1 ? "Parcelar em Até " + pagamentoNumeroMaximoParcelas?.prestacao + " Vezes ( " + pagamentoNumeroMaximoParcelas?.prestacao + " x " + (totalGeralPagamentos / pagamentoNumeroMaximoParcelas?.prestacao).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + " )." : "À Vista em " + pagamentoNumeroMaximoParcelas?.prestacao + " Vez ( " + pagamentoNumeroMaximoParcelas?.prestacao + " x " + (totalGeralPagamentos / pagamentoNumeroMaximoParcelas?.prestacao).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + " ).")}
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                    </>
                                    /* PAGAMENTO PEDIDO FINAL */

                                    :
                                    <>
                                        <Typography sx={{ fontSize: '15px', marginTop: '15px', marginLeft: '10px' }} color="text.primary" textAlign={"left"}>
                                            Efetue Reimpressão dos Recibos
                                        </Typography>
                                    </>

                                }
                            </Grid>


                            {/* INICIO DADOS CARTAO */}

                            {

                                meuFormaPagamentoTipo < 3 ? <></> : <>

                                    <Grid item xs={7} backgroundColor={'#FFFFF0'} style={{ display: 'flex', fontSize: '18px', textAlign: 'left', bgcolor: '#FFFFF0', alignItems: 'flex-end' }}>
                                        <FormControl sx={{ marginBottom: '10px' }}>
                                            <FormLabel id="demo-row-radio-buttons-group-label" sx={{ marginLeft: '10px' }}>Tipo de Cartão</FormLabel>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                            >
                                                <FormControlLabel sx={{ marginLeft: '10px', bgcolor: '#FFFFF0' }} value="CCredito" checked={cartaoTipoCartao === 0} onChange={(e) => TelaTipoDeCartaoCreditoOuDebito(0)} control={<Radio />} label="Crédito" />
                                                <FormControlLabel sx={{ marginLeft: '10px', bgcolor: '#FFFFF0' }} value="CDebito" checked={cartaoTipoCartao === 1} disabled={true} onChange={(e) => TelaTipoDeCartaoCreditoOuDebito(1)} control={<Radio />} label="Débito" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>

                                    {cartaoSolicitarCPF_CNPJ ?
                                        <Grid item xs={7} backgroundColor={'#FFFFF0'} style={{ display: 'flex', fontSize: '18px', textAlign: 'right', bgcolor: '#FFFFF0', alignItems: 'flex-end' }}>
                                            <TextField sx={{ marginLeft: '10px' }} id="cartaoCPF" name="cartaoCPF"
                                                onKeyUp={(event) => {
                                                    PesquisarCPF_CNPJ(event.target.value, event)
                                                }}
                                                inputProps={{ maxLength: 18 }}
                                                label="CPF/CNPJ do Portador" variant="outlined" size="small"
                                                defaultValue={""}
                                            />
                                        </Grid>
                                        : <></>}

                                    <Grid item xs={5} backgroundColor={'#FFFFF0'} style={{ display: 'flex', alignContent: 'left' }}>
                                        <Box display={'flex'} alignContent={'center'} height={'52px'} width={'auto'} >
                                            <img src={(cartaoSelecionado == null || cartaoSelecionado == "" ? cartoes_CVV : (cartaoSelecionado == 'VISA' ? cartoes_VISA : (cartaoSelecionado == 'MASTERCARD' ? cartoes_MASTERCARD : (cartaoSelecionado == 'AMEX' ? cartoes_AMEX :
                                                (cartaoSelecionado == 'DINERS' ? cartoes_DINERS : (cartaoSelecionado == 'ELO' ? cartoes_ELO : (cartaoSelecionado == 'HIPERCARD' ? cartoes_HIPERCARD : (cartaoSelecionado == 'HIPER' ? cartoes_HIPER : (cartaoSelecionado == 'CABAL' ? cartoes_CABAL : cartoes_CVV)))))))))} alt={cartaoSelecionado} />
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} backgroundColor={'#FFFFF0'} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                        <Typography sx={{ fontSize: '15px', color: '#FF0000', marginLeft: '10px' }} textAlign={"left"}>
                                            {cpf_cnpjError}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} backgroundColor={'#FFFFF0'} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                        <TextField id="cartaoNumero" name="cartaoNumero" fullWidth defaultValue={""} sx={{ marginLeft: '10px', marginTop: '3px', marginRight: '10px' }} onKeyUp={(event) => {
                                            TestarNumeroCartaoCredito(event.target.value, event)
                                        }} inputProps={{ maxLength: 19 }} label="Número do Cartão" variant="outlined" size="small" />
                                    </Grid>

                                    <Grid item xs={12} backgroundColor={'#FFFFF0'} style={{ display: 'flex', fontSize: '18px', textAlign: 'right', marginLeft: '10px' }}>
                                        <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                            {cartaoNumeroError}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} backgroundColor={'#FFFFF0'} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                        <TextField id="cartaoNome" name="cartaoNome" sx={{ marginLeft: '10px', marginTop: '15px', marginRight: '10px' }} fullWidth inputProps={{ maxLength: 100 }} label="Nome Completo Como Está no Cartão" onKeyUp={(event) => {
                                            TestarNomeCartao(event.target.value, event)
                                        }} variant="outlined" size="small"
                                            defaultValue={""}
                                        />
                                    </Grid>
                                    <Grid item xs={12} backgroundColor={'#FFFFF0'} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                        <Typography sx={{ fontSize: '15px', color: '#FF0000', marginLeft: '10px' }} textAlign={"left"}>
                                            {cartaoNomeError}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={5} backgroundColor={'#FFFFF0'} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                        <TextField id="cartaoValidade" name="cartaoValidade"
                                            onKeyUp={(event) => {
                                                TestarValidadeCartaoCredito(event.target.value, event)
                                            }} inputProps={{ maxLength: 5 }} label="Validade MM/AA" variant="outlined" size="small" sx={{ marginTop: "15px", marginLeft: '10px', marginRight: '10px' }}
                                            defaultValue={""}
                                        />
                                    </Grid>

                                    <Grid item xs={7} backgroundColor={'#FFFFF0'} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                        <TextField id="cartaoCVV" name="cartaoCVV" onKeyUp={(event) => {
                                            TestarCVV(event.target.value, event)
                                        }} inputProps={{ maxLength: 4 }} label="CVV Código de Segurança" variant="outlined" size="small" sx={{ marginTop: "15px", marginLeft: '10px', marginRight: '10px' }} fullWidth
                                            defaultValue={""}
                                        />
                                    </Grid>

                                    <Grid item xs={12} backgroundColor={'#FFFFF0'} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                        <Typography sx={{ fontSize: '15px', color: '#FF0000', marginLeft: '10px' }} textAlign={"left"}>
                                            {vencimentoError}
                                        </Typography>
                                    </Grid>

                                    {cartaoSolicitarCPF_CNPJ ?
                                        <Grid item xs={12} backgroundColor={'#FFFFF0'} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                            <FormControl fullWidth sx={{ marginRight: '20px' }}>
                                                <InputLabel id="opcao_parcelamentos-label" style={{ position: 'absolute', top: 15, left: 8, backgroundColor: '#FFFFF0', padding: '0 4px' }}>Parcelamentos</InputLabel>
                                                <Select
                                                    labelId="opcao_parcelamentos-label"
                                                    id="opcao_parcelamentos"
                                                    // multiple                                                                                                                
                                                    value={pagamentoOpcaoSelecionada}
                                                    onChange={handleChangeComboParcelamentos}
                                                    input={<OutlinedInput label="Opção de Parcelamento" sx={{ marginTop: '10px' }} />}
                                                    //renderValue={(selected) => selected.join(', ')}
                                                    renderValue={(selected) => selected}
                                                    MenuProps={MenuProps}
                                                    fullWidth
                                                    sx={{ marginLeft: '10px', marginRight: '4px', marginTop: '15px', bgcolor: '#FFFFF0' }}
                                                >
                                                    {pagamentoValorParcelas.map((parcela) => (
                                                        <MenuItem key={parcela} value={parcela}>
                                                            <Checkbox />
                                                            <ListItemText primary={parcela} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        : <></>}

                                    <Grid item xs={12} backgroundColor={'#FFFFF0'} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                        <Typography sx={{ fontSize: '15px', color: '#FF0000', marginLeft: '10px' }} textAlign={"left"}>
                                            {pagamentoNumeroParcelasError}
                                        </Typography>
                                    </Grid>
                                </>
                            }

                            {/* FINAL DADOS CARTAO  */}

                            <Grid item xs={12} style={{ textAlign: "left", alignContent: "left", alignItems: "left", backgroundColor: '#fffff0' }}>

                                {switchAbertas ?
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                    >
                                        <Button onClick={(e) => SalvarEfetuarPagamento(e)} variant="contained" startIcon={<MonetizationOnIcon />} style={{ backgroundColor: '#357a38', maxWidth: '300px', maxHeight: '25px', marginTop: '10px', marginBottom: '10px' }}>
                                            Efetuar Pagamento
                                        </Button>
                                        <Button variant="contained" startIcon={<MonetizationOnIcon />} style={{ backgroundColor: '#357a38', maxWidth: '300px', maxHeight: '25px', marginTop: '10px', marginBottom: '10px', marginLeft: '25px' }}>
                                            Crédito Avulso
                                        </Button>
                                    </Box>

                                    :

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                    >
                                        <Button onClick={() => handlePrint()} variant="contained" startIcon={<ReceiptIcon />} style={{ backgroundColor: '#357a38', maxWidth: '300px', maxHeight: '25px', marginTop: '39px', marginBottom: '45px', marginRight: '10px' }}>
                                            Extrato dos Itens
                                        </Button>
                                        <Button onClick={(e) => SalvarEfetuarPagamento(e)} variant="contained" startIcon={<ReceiptIcon />} style={{ backgroundColor: '#357a38', maxWidth: '300px', maxHeight: '25px', marginTop: '39px', marginBottom: '45px' }}>
                                            Recibo de Pagamento
                                        </Button>
                                    </Box>

                                }

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>


                {/* DATAGRID DETALHES DAS COMPRAS, DEVOLUÇÕES E PAGAMENTOS */}
                <Grid container sx={{ alignItems: "center" }}>
                    <Grid item xs={12} sx={{ fontFamily: `"Roboto", "Helvetica", "Arial", "sans-serif"`, fontSize: '16px', fontWeight: 'bold' }}>
                        <Box sx={{
                            display: 'flex', justifyContent: 'center', width: '98.4%', marginLeft: '10px',
                            [`.${gridClasses.cell}.branco`]: {
                                backgroundColor: '#ffffff',
                                color: '#000000',
                            },
                            [`.${gridClasses.cell}.amarelo`]: {
                                backgroundColor: '#FFF9EC',
                                color: '#000000',
                            },
                        }}>

                            <ThemeProvider theme={themeWithLocale}>
                                {/* <StyledDataGrid // <DATAGRID>
                                    ref={gridRef}
                                    headerHeight={35}
                                    keepNonExistentRowsSelected
                                    autoHeight
                                    getRowId={(saton) => saton.ids_saton + "-" + saton.ids_saton_loja}
                                    rows={saton}
                                    getRowClassName={getRowClassName}
                                    getCellClassName={getCellClassName}
                                    onSelectionModelChange={(row) => {
                                            setSelectionModel(row);
                                        TipoPagamento(1);
                                        desativarFiltro();
                                        //setFiltroAtivo(false);
                                        checarCalculoPagamentos();
                                        // VOLTAR efetuarCalculoPagamentos(row);
                                        // setFiltroAtivo(false);
                                    }}
                                    rowsPerPageOptions={[25, 50, 100]}
                                    pageSize={pageSizeContaFaturada}
                                    onPageSizeChange={(newPageSize) => setPageSizeContaFaturada(newPageSize)}
                                    columns={columns}
                                    rowHeight={34}
                                    // rowSelection={'single'}
                                    // checkboxSelection
                                    // disableSelectionOnClick
                                    localeText={localizedTextsMap}
                                    sx={{ fontSize: '12px', fontWeight: 'bold' }}
                                    selectionModel={selectionModel}
                                    checkboxSelection
                                    disableSelectionOnClick

                                // components={{
                                //     Toolbar: () => <CustomToolbar gridRef={gridRef} />,
                                //   }}
                                /> */}
                                <DataGrid
                                    headerHeight={35}
                                    keepNonExistentRowsSelected
                                    autoHeight
                                    getRowId={(saton) => saton.ids_saton + "-" + saton.ids_saton_loja}
                                    rows={saton}
                                    columns={columns}
                                    rowHeight={34}
                                    checkboxSelection
                                    selectionModel={selectionModel}                                    
                                    // onCellClick={(selection) => {
                                    //     // PegarDadosLinhaAtual(selection);
                                    //     // PegarDadosDevolucao(selection);
                                    // }}
                                    onSelectionModelChange={(row) => {
                                        //setSelectedRows(row);
                                        // if (filtroAtivo){
                                        //setSelectionModel(selectedRows);
                                        // }
                                        TipoPagamento(1);
                                        setSelectionModel(row);
                                        //desativarFiltro();
                                        //setFiltroAtivo(false);
                                        checarCalculoPagamentos();
                                        // VOLTAR efetuarCalculoPagamentos(row);
                                        // setFiltroAtivo(false);
                                    }}
                                    getRowClassName={getRowClassName}
                                    // getCellClassName={getCellClassName}
                                    rowsPerPageOptions={[25, 50, 100]}
                                    pageSize={pageSizeContaFaturada}
                                    onPageSizeChange={(newPageSize) => setPageSizeContaFaturada(newPageSize)}
                                    // columns={columns}
                                    // rowHeight={34}
                                    // // rowSelection={'single'}
                                    // // checkboxSelection
                                    // // disableSelectionOnClick
                                    localeText={localizedTextsMap}
                                    sx={{ fontSize: '12px', fontWeight: 'bold' }}
                                    // selectionModel={selectionModel}
                                    // checkboxSelection
                                    disableSelectionOnClick
                                />
                                {/* </Box> */}
                            </ThemeProvider>

                        </Box>
                    </Grid>
                </Grid>

                <ToastContainer />

                {
                    (showModalMeusCheques ?
                        <div>
                            <Modal
                                aria-labelledby="transition-modal-title"
                                aria-describedby="transition-modal-description"
                                open={showModalMeusCheques}
                                onClose={handleCloseModalMeusCheques}
                                closeAfterTransition
                                BackdropComponent={Backdrop}
                                BackdropProps={{
                                    timeout: 500,
                                }}
                            >
                                <Fade in={showModalMeusCheques}>
                                    <Box sx={modalStyle}>
                                        <DetalhesMeusCheques props={retornoApi} />
                                    </Box>
                                </Fade>
                            </Modal>
                        </div>
                        :
                        <div></div>)
                }

                {
                    openDialogoDevolucoes ?
                        <Dialogo
                            cabecalho="Deseja Solicitar a Devolução de:"
                            mensagem={dialogoMensagemDevolucoes}
                            open={openDialogoDevolucoes}
                            handleCloseNao={handleCloseNao.bind(this)}
                            handleCloseSim={handleCloseSim.bind(this)}
                        />
                        : <div></div>
                }
            </BrowserView>

            <MobileView>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-around"
                    alignItems="flex-start"
                    width={"99.2%"}
                    marginTop={"10px"}
                // height={"266px"}
                >
                    {/* SOMATÓRIO TOPO ESQUERDO */}
                    <Grid item xs={12} height={"100%"} sx={{ fontFamily: `"Roboto", "Helvetica", "Arial", "sans-serif"`, fontSize: '10px', fontWeight: 'bold' }}>

                        <Grid container sx={{ alignItems: "center", marginLeft: '10px' }}>

                            <Grid item xs={12} sx={{ fontFamily: `"Roboto", "Helvetica", "Arial", "sans-serif"`, fontSize: '10px', fontWeight: 'bold', marginTop: '1px' }}>
                                <Box sx={{ border: 1, borderColor: '#ddd', width: '98.4%', borderRadius: '6px' }}>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="flex-start"
                                        alignItems="flex-start"
                                    >
                                        <Grid item xs={12} sx={{ alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#EAFAF1", borderBottom: "solid 1px #ddd" }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={"10px"}>Cliente: <b>{usuarioLogado.replace("_", "-")}</b> Nome: <b>{nomeFullRazaoSocialLogado}</b></Typography>
                                        </Grid>

                                        <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#f5f5dc' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'11px'}>Quantidades</Typography>
                                        </Grid>
                                        <Grid item xs={5.67} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#f5f5dc' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'11px'} marginLeft={'10px'} marginTop={'12px'}>Tipo Operação</Typography>
                                        </Grid>
                                        <Grid item xs={4.05} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#f5f5dc' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'11px'} marginLeft={'10px'} marginTop={'12px'}>Valor Total R$</Typography>
                                        </Grid>


                                        <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'}><b>{quantidadeTotalVendas}</b></Typography>
                                        </Grid>
                                        <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={'5px'} marginTop={'12px'}><b>COMPRAS</b></Typography>
                                        </Grid>
                                        <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginRight={'10px'} marginTop={'12px'}><b>{valorTotalVendas.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                                        </Grid>

                                        <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'}><b>{quantidadeTotalDevolucoes}</b></Typography>
                                        </Grid>
                                        <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={'5px'} marginTop={'12px'}><b>DEVOLUÇÕES</b></Typography>
                                        </Grid>
                                        <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginRight={'10px'} marginTop={'12px'}><b>{valorTotalDevolucoes.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                                        </Grid>

                                        <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'}><b>{quantidadeTotalCreditos}</b></Typography>
                                        </Grid>
                                        <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={'5px'} marginTop={'12px'}><b>CRÉDITOS</b></Typography>
                                        </Grid>
                                        <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginRight={'10px'} marginTop={'12px'}><b>{valorTotalCreditos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                                        </Grid>


                                        <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'}><b>{quantidadeTotalDuplicatas}</b></Typography>
                                        </Grid>
                                        <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={'5px'} marginTop={'12px'}><b>DUPLICATAS</b>
                                                <IconButton onClick={() => FiltrarDados()} color="primary" aria-label="Ver Duplicatas" style={{ maxHeight: '18px', marginLeft: '1px' }}>
                                                    <VisibilityIcon style={{ color: (filtroAtivo ? "red" : "green") }} />
                                                </IconButton>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginRight={'10px'} marginTop={'12px'}><b>{valorTotalDuplicatas.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                                        </Grid>

                                        <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'}><b>{quantidadeTotalChequesDevolvidos}</b></Typography>
                                        </Grid>
                                        <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={'5px'} marginTop={'12px'}><b>CHEQUES DEVOLVIDOS</b>
                                                <IconButton onClick={() => ShowModalMeusCheques()} color="primary" aria-label="Ver Duplicatas" style={{ maxHeight: '9px', marginLeft: '-2px' }}>
                                                    <VisibilityIcon style={{ color: (filtroAtivo ? "red" : "green") }} />
                                                </IconButton>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginRight={'10px'} marginTop={'12px'}><b>{valorTotalChequesDevolvidos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                                        </Grid>

                                        <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                            <img src={SetaDireita} alt="Seta" style={{ width: '23px', height: 'auto', marginTop: '1px' }} />
                                        </Grid>
                                        <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={'5px'} marginTop={'20px'}><b>TOTAL GERAL R$</b></Typography>
                                        </Grid>
                                        <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", backgroundColor: '#fffff0' }}>
                                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginRight={'10px'} marginTop={'12px'}><b>{totalGeral.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                                        </Grid>

                                    </Grid>
                                </Box>
                            </Grid>

                        </Grid>
                    </Grid>

                    {/* FILTROS TOPO CENTRO */}

                    <Grid item xs={12} height={"100%"} sx={{ fontFamily: `"Roboto", "Helvetica", "Arial", "sans-serif"`, fontSize: '10px', fontWeight: 'bold', border: 1, borderColor: '#ddd', borderRadius: '6px', marginLeft: "6px", marginTop: "10px" }}
                    >
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                        >
                            <Grid item xs={12} sx={{ alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#EAFAF1", borderBottom: "solid 1px #ddd", borderTopLeftRadius: '6px' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginLeft={"10px"} > Usuário: <b>{nomeUsuarioLogado}</b></Typography>
                            </Grid>

                            <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#f5f5dc' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'}>Quantidades</Typography>
                            </Grid>
                            <Grid item xs={5.67} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#f5f5dc' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={'10px'} marginTop={'12px'}>Tipo Operação</Typography>
                            </Grid>
                            <Grid item xs={4.05} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#f5f5dc' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={'10px'} marginTop={'12px'}>Valor Total R$</Typography>
                            </Grid>

                            <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'}><b>{quantidadeTotalVendasPagamentos}</b></Typography>
                            </Grid>
                            <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={'20px'} marginTop={'12px'}><b>COMPRAS</b></Typography>
                            </Grid>
                            <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginRight={'10px'} marginTop={'12px'}><b>{valorTotalVendasPagamentos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                            </Grid>

                            <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'}><b>{quantidadeTotalDevolucoesPagamentos}</b></Typography>
                            </Grid>
                            <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={'20px'} marginTop={'12px'}><b>DEVOLUÇÕES</b></Typography>
                            </Grid>
                            <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginRight={'10px'} marginTop={'12px'}><b>{valorTotalDevolucoesPagamentos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                            </Grid>


                            <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'}><b>{quantidadeTotalCreditosPagamentos}</b></Typography>
                            </Grid>
                            <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={'20px'} marginTop={'12px'}><b>CRÉDITOS</b></Typography>
                            </Grid>
                            <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginRight={'10px'} marginTop={'12px'}><b>{valorTotalCreditosPagamentos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                            </Grid>

                            <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'}><b>{quantidadeDescontosPagamentos}</b></Typography>
                            </Grid>
                            <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", borderBottom: "solid 1px #ddd", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginLeft={'20px'} marginTop={'12px'}><b>DESCONTOS</b></Typography>
                            </Grid>
                            <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", borderBottom: "solid 1px #ddd", backgroundColor: '#fffff0' }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'12px'} marginRight={'10px'} marginTop={'12px'}><b>{((meuFormaPagamentoTipo <= 2 ? valorDescontosPagamentos : 0.00)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                            </Grid>
                            <Grid item xs={2.27} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0', borderBottom: "solid 1px #ddd" }}>
                                <img src={SetaDireita} alt="Seta" style={{ width: '21px', height: 'auto' }} />
                            </Grid>
                            <Grid item xs={5.67} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#f5f5dc", backgroundColor: '#fffff0', borderBottom: "solid 1px #ddd" }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginLeft={'20px'} marginTop={'20px'}><b>TOTAL GERAL R$</b></Typography>
                            </Grid>
                            <Grid item xs={4.05} style={{ textAlign: "right", alignContent: "right", alignItems: "right", backgroundColor: '#fffff0', borderBottom: "solid 1px #ddd" }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginRight={'10px'} marginTop={'12px'}><b>{totalGeralPagamentos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</b></Typography>
                            </Grid>

                        </Grid>
                    </Grid>


                    {/* FILTROS TOPO DIREITO */}
                    <Grid item xs={12} sx={{
                        fontFamily: `"Roboto", "Helvetica", "Arial", "sans-serif"`, fontSize: '10px', fontWeight: 'bold', height: '100%', marginTop: '10px', borderBottomLeftRadius: '6px', borderBottomRightRadius: '6px'
                    }}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            sx={{ border: 1, borderColor: '#ddd', borderRadius: '6px' }}
                        >
                            <Grid item xs={12} sx={{ alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#EAFAF1" }}>
                                <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'} marginLeft={"10px"} ><b>Filtros de Pesquisa</b></Typography>
                            </Grid>

                            <Grid item xs={4} style={{ textAlign: "center", alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#f5f5dc", textAlign: 'center', backgroundColor: '#fffff0' }}>
                                <Box component="form">
                                    <TextField
                                        type="tel"
                                        id="textFiltroCodigo"
                                        label="Código"
                                        variant="outlined"
                                        onChange={(e) => codigoDigitado(e)}
                                        value={filtroCodigo}
                                        size="small"
                                        sx={{ marginLeft: "10px", marginTop: '6px' }}
                                    />
                                </Box>
                            </Grid>

                            <Grid item xs={8} style={{ textAlign: "left", alignContent: "left", alignItems: "left", backgroundColor: '#fffff0' }}>
                                <Box component="form">
                                    <TextField
                                        type="tel"
                                        id="textFiltroIDVenda"
                                        label="ID Venda-Loja"
                                        variant="outlined"
                                        onChange={(e) => idVenda_lojaDigitado(e)}
                                        value={filtroIDVenda_Loja}
                                        size="small"
                                        sx={{ marginTop: '6px', marginLeft: '12px' }}
                                    />
                                </Box>
                            </Grid>

                            <Grid item xs={6} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                <Box component="form" sx={{ marginTop: "6px", marginLeft: "6px" }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            className={classesDatePicker.root}
                                            mask="__/__/____"
                                            label="Data Inicial"
                                            inputFormat="DD/MM/YYYY"
                                            value={filtroDataInicial}
                                            onChange={(e) => dataInicialDigitada(e)}
                                            disableOpenPicker
                                            renderInput={(params) => <TextField {...params} size="small" sx={{ marginTop: "6.4px", marginLeft: "4px" }}
                                                inputProps={
                                                    {
                                                        ...params.inputProps,
                                                        placeholder: "dd/mm/aaaa"
                                                    }
                                                }
                                            />}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </Grid>

                            <Grid item xs={6} style={{ textAlign: "left", alignContent: "left", alignItems: "left", textAlign: "left", bgcolor: "#f5f5dc", backgroundColor: '#fffff0' }}>
                                <Box component="form" sx={{ marginTop: "6px", marginLeft: "8px", marginRight: "6px" }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            className={classesDatePicker.root}
                                            mask="__/__/____"
                                            label="Data Final"
                                            inputFormat="DD/MM/YYYY"
                                            value={filtroDataFinal}
                                            onChange={(e) => dataFinalDigitada(e)}
                                            disableOpenPicker
                                            renderInput={(params) => <TextField {...params} size="small" sx={{ marginTop: "6.4px", marginLeft: "4px" }}
                                                inputProps={
                                                    {
                                                        ...params.inputProps,
                                                        placeholder: "dd/mm/aaaa"
                                                    }
                                                }
                                            />}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </Grid>

                            <Grid item xs={12} justifyContent={"space-around"} style={{ backgroundColor: '#fffff0', borderBottom: "solid 1px #ddd" }}>
                                <Box component="form" sx={{ marginTop: "12px" }}>
                                    {/* <Stack direction="row" spacing={2}> */}

                                    <FormControlLabel control={
                                        <Switch defaultChecked checked={switchAbertas} style={{ color: "green", marginRight: '10px' }} />
                                    } label={(switchAbertas ? "Abertas" : "Fechadas")} onChange={toggleAbertaChecked} sx={{ minWidth: "150px" }} />

                                    <IconButton onClick={() => FiltrarDados()} color="primary" aria-label="Adicionar Filtro">
                                        <FilterAltIcon style={{ color: (filtroAtivo ? "red" : "green") }} />
                                    </IconButton>

                                    <IconButton onClick={() => LimparFiltrarDados()} color="primary" aria-label="Remover Filtro">
                                        <FilterAltOffIcon style={{ color: "green" }} />
                                    </IconButton>
                                    <Button variant="contained" startIcon={<ArchiveIcon />} onClick={(e) => EfetuarSolicitacaoParaDevolucoes(e)} style={{ backgroundColor: '#357a38', maxWidth: '140px', maxHeight: '25px', marginTop: '12px', marginBottom: '30px', marginLeft: "35px" }}>
                                        Devoluções
                                    </Button>
                                    {/* </Stack> */}
                                </Box>
                            </Grid>


                            {/* DATAGRID DETALHES DAS COMPRAS, DEVOLUÇÕES E PAGAMENTOS */}
                            <Grid container sx={{ alignItems: "center" }}>
                                <Grid item xs={12} sx={{ minHeight: '700px', fontFamily: `"Roboto", "Helvetica", "Arial", "sans-serif"`, fontSize: '10px', fontWeight: 'bold' }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', height: '100%' }}>
                                        <ThemeProvider theme={themeWithLocale}>
                                            <Box
                                                sx={{
                                                    minHeight: '600px',
                                                    height: '100%',
                                                    width: '100%',
                                                    '& .super-app-theme--cell-dark': {
                                                        backgroundColor: 'rgb(0, 0, 0)',
                                                        color: 'blue',
                                                        fontWeight: '600',
                                                    },
                                                    '& .super-app-theme--cell-light': {
                                                        backgroundColor: 'rgba(157, 255, 118, 0.49)',
                                                        color: '#1a3e72',
                                                        fontWeight: '600',
                                                    },
                                                    '& .super-app-theme--cell-quitada': {
                                                        backgroundColor: 'rgba(214, 234, 248, 0.49)',
                                                        color: '#1a3e72',
                                                        fontWeight: '600',
                                                    },
                                                    '& .super-app-theme--cell-devolucoes': {
                                                        backgroundColor: '#e9f5eaff',
                                                        color: '#000',
                                                        fontWeight: '600',
                                                    },
                                                    '& .super-app-theme--cell-padrao': {
                                                        backgroundColor: '#fff',
                                                        color: '#000',
                                                        fontWeight: '600',
                                                    },
                                                }}
                                            >
                                                <div style={{ height: 'auto', overflow: "auto", minHeight: "300px" }}>
                                                    <DataGrid
                                                        headerHeight={35}
                                                        autoHeight={true}
                                                        getRowId={(saton) => saton.ids_saton + "-" + saton.ids_saton_loja}
                                                        rows={saton}
                                                        onCellClick={(selection) => {
                                                            //PegarDadosLinhaAtual(selection);
                                                            //PegarDadosDevolucao(selection);
                                                        }}
                                                        onSelectionModelChange={(row) => {
                                                            efetuarCalculoPagamentos(row);
                                                        }}
                                                        getRowClassName={(params) => {
                                                            if ((!selectionModel.includes(params.id) && !selectionModelDevolucoes.includes(params.id) && !selectionModelNotaInteira.includes(params.id))) {
                                                                return `super-app-theme--cell-padrao`;
                                                            }
                                                            if ((selectionModelDevolucoes.includes(params.id))) {
                                                                return `super-app-theme--cell-devolucoes`;
                                                            }
                                                            else {
                                                                return `super-app-theme--cell-${(selectionModel.includes(params.id) ? "dark" : "quitada")}`;
                                                            }
                                                        }}
                                                        rowsPerPageOptions={[25, 50, 100]}
                                                        pageSize={pageSizeContaFaturada}
                                                        onPageSizeChange={(newPageSize) => setPageSizeContaFaturada(newPageSize)}
                                                        columns={columns}
                                                        rowHeight={34}
                                                        // rowSelection={'single'}
                                                        // checkboxSelection
                                                        // disableSelectionOnClick
                                                        localeText={localizedTextsMap}
                                                        // selectionModel={selectionModel}
                                                        checkboxSelection
                                                        disableSelectionOnClick
                                                        sx={{
                                                            '.MuiDataGrid-virtualScroller': {
                                                                overflowY: 'auto !important',
                                                                // example of maxHeight
                                                                minHeight: '700px',
                                                                maxHeight: 'calc(100vh - 705px) !important',
                                                            },

                                                            '.MuiDataGrid-checkboxInput': {
                                                                display: 'none',
                                                            },



                                                            fontSize: '12px', fontWeight: 'bold'
                                                        }}
                                                    />
                                                </div>
                                            </Box>
                                        </ThemeProvider>
                                    </Box>
                                </Grid>
                            </Grid>

                        </Grid>

                    </Grid>
                </Grid>


                <Grid
                    container
                    direction="row"
                    justifyContent="space-around"
                    alignItems="flex-start"
                    width={"99.2%"}
                    marginTop={"10px"}
                // height={"266px"}
                >
                    {/* SOMATÓRIO TOPO ESQUERDO */}
                    <Grid item xs={12}>
                        {/* PAGAMENTO PEDIDO INÍCIO */}
                        <Box component="form" sx={{ marginBottom: '20px', backgroundColor: '#f5f5dc' }}>
                            <Typography variant="caption" fontFamily={'roboto'} fontSize={'13px'}><b>Formas de Pagamentos</b></Typography>

                            <Stack spacing={2} direction="row">
                                <Stack direction="column">
                                    {/* <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                        Alguns Tipos de Pagamentos Podem Possuir Descontos*
                      </Typography>
                      <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} /> */}
                                    <Stack direction="row" maxHeight={50}>

                                        <Grid container spacing={2}>
                                            <Grid item xs={4}>
                                                <img src={(meuFormaPagamentoTipo == 1 ? pixIcon : pixIconDisabled)} onClick={(e) => TipoPagamento(1)} style={{ height: '42px', maxHeight: '42px', cursor: 'pointer', marginLeft: '16px' }} />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <img src={(meuFormaPagamentoTipo == 2 ? boletoIcon : boletoIconDisabled)} onClick={(e) => TipoPagamento(2)} style={{ height: '42px', maxHeight: '42px', marginLeft: '35px', cursor: 'pointer' }} />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <img src={(meuFormaPagamentoTipo == 3 ? cartoes_selecaoIcon : cartoes_selecaoIconDisabled)} onClick={(e) => TipoPagamento(3)} sx={{ height: '38px', maxHeight: '38px' }} style={{ cursor: 'pointer', marginLeft: '35px', height: '38px' }} />
                                            </Grid>
                                        </Grid>

                                    </Stack>
                                    <Typography sx={{ fontSize: '15px', marginTop: '5px', marginLeft: '10px' }} color="text.primary" textAlign={"left"}>
                                        {(pagamentoNumeroMaximoParcelas?.prestacao != null && pagamentoNumeroMaximoParcelas?.prestacao > 1 ? "Parcelar em Até " + pagamentoNumeroMaximoParcelas?.prestacao + " Vezes ( " + pagamentoNumeroMaximoParcelas?.prestacao + " x " + (totalGeralPagamentos / pagamentoNumeroMaximoParcelas?.prestacao).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + " )." : "À Vista em " + pagamentoNumeroMaximoParcelas?.prestacao + " Vez ( " + pagamentoNumeroMaximoParcelas?.prestacao + " x " + (totalGeralPagamentos / pagamentoNumeroMaximoParcelas?.prestacao).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + " ).")}
                                    </Typography>
                                </Stack>
                            </Stack>


                            <Button onClick={(e) => SalvarEfetuarPagamento(e)} variant="contained" startIcon={<MonetizationOnIcon />} style={{ backgroundColor: '#357a38', maxWidth: '300px', maxHeight: '25px', marginTop: '10px', marginBottom: '10px' }}>
                                Efetuar Pagamento
                            </Button>
                            <Button variant="contained" startIcon={<MonetizationOnIcon />} style={{ backgroundColor: '#357a38', maxWidth: '300px', maxHeight: '25px', marginTop: '10px', marginBottom: '25px', marginLeft: '25px' }}>
                                Crédito Avulso
                            </Button>
                        </Box>

                        {/* PAGAMENTO PEDIDO FINAL */}
                    </Grid>
                </Grid>

                <ToastContainer />

                {
                    (showModalMeusCheques ?
                        <div>
                            <Modal
                                aria-labelledby="transition-modal-title"
                                aria-describedby="transition-modal-description"
                                open={showModalMeusCheques}
                                onClose={handleCloseModalMeusCheques}
                                closeAfterTransition
                                BackdropComponent={Backdrop}
                                BackdropProps={{
                                    timeout: 500,
                                }}
                            >
                                <Fade in={showModalMeusCheques}>
                                    <Box sx={modalStyle}>
                                        <DetalhesMeusCheques props={retornoApi} />
                                    </Box>
                                </Fade>
                            </Modal>
                        </div>
                        :
                        <div></div>)
                }

                {
                    openDialogoDevolucoes ?
                        <Dialogo
                            cabecalho="Deseja Solicitar a Devolução de:"
                            mensagem={dialogoMensagemDevolucoes}
                            open={openDialogoDevolucoes}
                            handleCloseNao={handleCloseNao.bind(this)}
                            handleCloseSim={handleCloseSim.bind(this)}
                        />
                        : <div></div>
                }
            </MobileView>


        </div >
    );
}
export default Compras_Faturadas;